import { AbstractControl, UntypedFormControl, ValidationErrors, UntypedFormArray } from '@angular/forms';
import { FormlyFieldConfig, FormlyForm } from '@ngx-formly/core';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';
import { Options } from '@rp3e11/ngx-slider';
import { first as _first, some as _some, get as _get, 
    last as _last, map as _map, includes as _includes,
toString as _toString, forEach as _forEach, isNull as _isNull, 
isUndefined as _isUndefined, isEmpty as _isEmpty, lowerCase as _lowerCase, find as _find, forEach, 
max as _max, toNumber as _toNumber, indexOf, startCase as _startCase, intersection as _intersection, isEqual as _isEqual, set as _set, indexOf as _indexOf, capitalize as _capitalize, 
filter as _filter, castArray as _castArray, isPlainObject as _isPlainObject, isString as _isString, endsWith as _endsWith} from 'lodash-es';
import { distinctUntilChanged, filter, map, tap, zipAll } from 'rxjs/operators';
import { getUuid } from 'src/app/connector-studio/utilities/helpers';
import { CheckboxWrapperComponent } from '../components/checkbox-wrapper/checkbox-wrapper.component';
import { InterpolatePipe } from '../pipes/interpolate/interpolate.pipe';
import { NS_AdminService, NS_ConnectorStudioService, NS_UserService } from '../namespaces';
import type { SnackBarService } from 'src/app/snack-bar.service';
import cronstrue from 'cronstrue';

export const checkSome = (object, value) => {
    return _some(object, (v, k) => {
        return _get(object, `[${k}]`) === value;
    })
}

export const operators = {
    'or': (pairs) => {
        return  {
            "or": generateCondition(pairs)
        }
    },
    'and': (pairs) => {
        return {
            "and": generateCondition(pairs)
        }
    },
    'role': (roles) => {
        return {
            "in": [
                {
                    "var": "role",
                },
                roles
            ]
        }
    },
    'roleExists': (roles) => {
        return {
            "exists": [
                {
                    "var": "role",
                },
                roles
            ]
        }
    },
    'roleIntersection': (roles) => {
        return {
            "intersection": [
                {
                    "var": "role",
                },
                roles
            ]
        }
    }
}

export const generateCondition = (pairs) => {
    return _map(pairs, pair => {
        return {
            "==": [ 
                {
                    "var": _first(pair)
                }, 
                _last(pair)
            ]
        }
    })
}

export const composeRoleAndFeatureFlagsRules = (flags, roles) => {
    return {
        "and": [
            flags, 
            roles
        ]
    }
}

export const OAUTH_PROPERTIES_ARRAY = ['authorizationEndpoint', 'authorizationQueryParams', 'authorizationHeaderParams', 'authorizationRequestBody', 'authorizationRequestBodyType', 'authorizationRequestMethod', 'enablePkce', 'pkceCodeChallengeMethod']

export const PKCE_PROPERTIES_ARRAY = ['enablePkce', 'pkceCodeChallengeMethod']

export const checkIfLastStepReached = (stepJson) => {
    return (stepJson === 'no_next_step')
}

export const templateCategoryRoleMap = {
    'saras-templates': NS_UserService.SARAS_TEMPLATE_ADMIN_ROLES,
    'org-templates': NS_UserService.ORG_TEMPLATE_ADMIN_ROLES
  }

export const templateCategoryFeatureFlagMap = {
    'saras-templates': { "saras": "Yes" },
    'org-templates': {"company": "Yes"}
}

export const  getCurrentDate = ()  =>{
    const today = new Date();
    const currentDate = today.toISOString();
    return currentDate;
  }

export const DATABASE_SOURCES_FOR_MIN_YEARS = [
    "AMAZONAURORA",
    "MYSQL",
    "AMAZONRDSMYSQL",
    "GOOGLECLOUDSQLMYSQL",
    "SPREECOMMERCE",
    "OSCOMMERCE",
    "WOOCOMMERCE",
    "PRESTASHOP",
    "LOADEDCOMMERCE",
    "MARIADB",
    "MAGENTO",
    "MARIADB",
    "POSTGRES",
    "AMAZONRDSPOSTGRES",
    "AURORAPOSTGRES",
    "GCPOSTGRES",
    "RDSSQLSERVER",
    "MSSQLSERVER",
    "GCPSQLSERVER",
    "AMAZONREDSHIFT",
    "CAPILLARY",
    "NETSUITE"
]


export const getPastYearsCountFromToday = (previousYear: number) => {
    // Get the current date
    const currentDate = new Date();

    // Set the reference date to 1990
    const referenceDate = new Date(previousYear, 0, 1); // Months are zero-indexed, so 0 is January

    // Calculate the year difference
    let yearDifference = currentDate.getFullYear() - referenceDate.getFullYear();

    // Adjust the year difference based on the month and day
    if (currentDate.getMonth() < referenceDate.getMonth() ||
       (currentDate.getMonth() === referenceDate.getMonth() &&
        currentDate.getDate() < referenceDate.getDate())
    ) {
        // If the current date's month and day are before the reference date's month and day
        yearDifference--;
    }

    return yearDifference;
}


export const getXYearsAgo = (x) => {
    // Get the current date
    const today = new Date();

    // Get the current year
    const currentYear = today.getFullYear();

    // Set the date to 20 years in the future by setting the year to the current year plus 20
    const pastDate = today.setFullYear(currentYear - x);
    // Convert the date to a string in the "yyyy-mm-dd" format
    const pastDateString = new Date(pastDate).toISOString();

    return pastDateString;
}


export const datonStudioFormlyFieldMap = {
    'RADIO_BUTTON': 'radio',
    'RADIO': 'select',
    'CHECKBOX': 'select',
    'TEXT': 'input',
    'INTEGRATION_NAME': 'input',
    'TEMPLATE_NAME': 'input',
    'INTEGER': 'input',
    'LONG': 'input',
    'FLOAT': 'input',
    'DOUBLE': 'input',
    'NUMBER': 'input',
    'EMAIL': 'input',
    'PASSWORD': 'input',
    'CHECKBOX_TABLE': '',
    'CHECKBOX_CARD': '',
    'DATE_PICKER': '',
    'DATETIME_PICKER': '',
    'TABLE_SELECT': 'virtual-scroll-grid',
    'COLUMN_SELECT': 'column-accordion',
    'HISTORY_PICKER': 'datepicker',
    'FIXED_VALUES_SLIDER': 'ngx-slider',
    'ADVANCED_CONFIGURATION': '',
    'ACCORDION_GROUP': 'accordion',
    'DROPDOWN_LIST': 'select',
    'ENTITY_SELECT':  'entity-select-type',
    'FREQUENCY_SELECT': 'frequency-select-type'
}

export const datonStudioFormlyFieldAppearanceMap = {
    'RADIO_BUTTON': '',
    'CHECKBOX': 'outline',
    'TEXT': 'outline',
    'INTEGRATION_NAME': 'outline',
    'TEMPLATE_NAME': 'outline',
    'INTEGER': 'outline',
    'LONG': 'outline',
    'FLOAT': 'outline',
    'DOUBLE': 'outline',
    'NUMBER': 'outline',
    'EMAIL': 'outline',
    'PASSWORD': 'outline',
    'CHECKBOX_TABLE': '',
    'CHECKBOX_CARD': '',
    'DATE_PICKER': 'outline',
    'DATETIME_PICKER': 'outline',
    'TABLE_SELECT': '',
    'COLUMN_SELECT': '',
    'HISTORY_PICKER': 'outline',
    'FIXED_VALUES_SLIDER': '',
    'ADVANCED_CONFIGURATION': '',
    'ACCORDION_GROUP': '',
    'DROPDOWN_LIST': 'outline',
}

export const formlyFieldPropsTypeMap = {
    'PASSWORD': 'password',
}

export const formatFormlySliderFieldLabel = (value: number): string => {
    return `${value}h`;
}

export const generateNGXSliderStepArray = (values, labels) => {
    return _map(values, (value, index) => {
        return {
            value: value, 
            legend: labels[index]
        }
    })
}

export const getNGXSliderProps = (field) => {
    const sliderProps: Options = {
        showTicks: true,
        hideLimitLabels: true, 
        stepsArray: generateNGXSliderStepArray(field.values, field.labels) || [
            { value: '1', legend: '1h' },
            { value: '2', legend: '2h' },
            { value: '3', legend: '3h' },
            { value: '4', legend: '4h' },
            { value: '5', legend: '5h' },
            { value: '6', legend: '6h' },
            { value: '7', legend: '7h' },
            { value: '8', legend: '8h' },
            { value: '9', legend: '9h' },
        ]
    }
    return sliderProps;
}

/**
 * Formats a history date value into a local Date object.
 * Parses date strings directly without timezone conversion to avoid T-1 date shifts.
 * @param value - Date value in MM/DD/YYYY, ISO, or timestamp format
 * @returns Local Date object, or null if value is falsy
 */
export const parseHistoryValue = (value: string | number | null): Date | null => {
    if(value) {
        if (typeof value === 'string' && value.includes('/')) {
            const [month, day, year] = value.split('/').map(Number);
            return new Date(year, month - 1, day);
        }
        if (typeof value === 'string' && value.includes('-')) {
            const [year, month, day] = value.substring(0, 10).split('-').map(Number);
            return new Date(year, month - 1, day);
        }
        const dateObj = new Date(value);
        return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
    }
    return null;
}



export const isFormlyFieldOptionRequired = (fieldType) => {
    return _includes(['RADIO_BUTTON', 'CHECKBOX','DROPDOWN_LIST', 'RADIO'], fieldType)
}
export const fieldsNotRequireMultiple = (inputElementType) =>{
    return _includes(['DROPDOWN_LIST'], inputElementType)
}

export const isFormlyFieldHooksRequired = (fieldName) => {
    return _includes(['region', 'integration_name', 'TEMPLATE_NAME', 'template_list'], fieldName)
}

export const isFormlyFieldHooksRequiredInputType = (fieldType) => {
    return _includes([ 'HISTORY_PICKER' ], fieldType)
}

export const isFormlyFieldReloadRequired = (fieldType) => {
    return _includes([ 'HISTORY_PICKER' ], fieldType)
}

export const isFormlyFieldMultiplePropsRequired = (fieldType) => {
    return _includes(['select'], fieldType)
}

export const isFormlyFieldBindValuePropsRequired = (fieldType) => {
    return _includes(['select'], fieldType)
}

export const isEntityType = (InputElementType) =>{
    return _includes(['entity-select-type'], InputElementType);
}

export const isAgGridRowDataRequired = (inputElementType) => {
    return _includes(['virtual-scroll-grid'], inputElementType)
}

export const isAgGridColumnDefsRequired = (inputElementType) => {
    return _includes(['table-grid'], inputElementType)
}

export const isFormlyFieldArrayRequired = (inputElementType) => {
    return _includes(['virtual-scroll-grid'], inputElementType)
}

export const isFormlyFieldGroupRequired = (inputElementType) => {
    return _includes(['COLUMN_SELECT', 'ACCORDION_GROUP', 'HISTORY_PICKER', 'ENTITY_SELECT', 'FREQUENCY_SELECT'], inputElementType)
}

export const isFormlyFieldKeyNotRequired = (inputElementType) => {
    return _includes(['COLUMN_SELECT'], inputElementType)
}

export const isFormlyDatePickerOptionsRequired = (inputElementType) => {
    return _includes(['HISTORY_PICKER'], inputElementType)
}

export const isFormlySliderPropsRequired = (inputElementType) => {
    return _includes(['FIXED_VALUES_SLIDER'], inputElementType)
}

export const isFormlyFieldTypeRequired = (inputElementType) => {
    return _includes(['RADIO_BUTTON', 'CHECKBOX', 'TEXT', 'INTEGRATION_NAME', 'TEMPLATE_NAME' , 'INTEGER', 'LONG', 'FLOAT', 'DOUBLE', 'NUMBER', 'EMAIL', 'PASSWORD', 'CHECKBOX_TABLE', 'CHECKBOX_CARD', 'DATE_PICKER', 'DATETIME_PICKER', 'TABLE_SELECT', 'COLUMN_SELECT', 'FIXED_VALUES_SLIDER', 'ADVANCED_CONFIGURATION', 'ACCORDION_GROUP', 'DROPDOWN_LIST', 'ENTITY_SELECT', 'FREQUENCY_SELECT'], inputElementType)
}

export const isFormlyFieldWrapperRequired = (inputElementType) => {
    return _includes(['FIXED_VALUES_SLIDER', 'DROPDOWN_LIST', 'RADIO_BUTTON', 'HISTORY_PICKER', 'TEXT'], inputElementType)
}

export const isFormlyFieldWrapperReqforAccordion = (inputElementType) => {
    return _includes(['loading_mode','loading_nested_objects'], inputElementType)
}

export const isFormlyFieldValidationRequired = (inputElementType) => {
    return _includes(['INTEGRATION_NAME', 'TEMPLATE_NAME'], inputElementType)
}

export const isFormlyFieldIntegrationNamesPropRequired = (inputElementType) => {
    return _includes(['INTEGRATION_NAME'], inputElementType)
}

export const isFormlyFieldTemplateNamesPropRequired = (inputElementType) => {
    return _includes(['TEMPLATE_NAME'], inputElementType);
}

export const isFormlyFieldReadOnlyRequired = (inputElementType) => {
    return _includes(['INTEGRATION_NAME', 'TEMPLATE_NAME'], inputElementType)
}

export const isFormlyFieldModeRequired = (inputElementType) => {
    return _includes(['ACCORDION_GROUP'], inputElementType)
}

export const existingIntegrationNameValidation = (control: any): ValidationErrors => {
    return !_includes(_get(_first(control._fields), 'props.existingIntegrationNames'), control.value) ? null : { 'existingIntegrationName': true };
}
    
export const existingTemplateNameValidation = (control: any): ValidationErrors => {
    return !_includes(_get(_first(control._fields), 'props.existingTemplateNames'), control.value)? null : { 'existingTemplateName': true }
}

export const cloneIntegrationNameValidation = (control: any): ValidationErrors => {
    return !_includes(_get(_first(control._fields), 'props.existingIntegrationNames'), control.value) ? null : { 'checkClonedIntegrationName': true };
}

export const cronValidator = (control: AbstractControl, field: FormlyFieldConfig): ValidationErrors => {
    const cronFrequency = _get(control, 'value')
    if(cronFrequency !== "") {
        const parent = _get(field, 'parent');
        let isValid = false;
        if(_get(parent, 'props.cronFlavor') === 'quartz') {
            const quartzRegex = /^(\d{1,2}|\*|\/|-|,)+\s+(\d{1,2}|\*|\/|-|,)+\s+([01]?\d|2[0-3]|\*|\/|-|,)+\s+(\*|\?|L|LW|\d{1,2}|\d{1,2}W|\/|-|,)+\s+(\*|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC|\d{1,2}(\/\d+)?|\/|-|,)+\s+(\*|\?|MON|TUE|WED|THU|FRI|SAT|SUN|\d{1,2}(\/\d+)?|\/|-|,|#\d)+(\s+(\d{4}|\d{2}|\*)?)?$/;
            isValid = quartzRegex.test(cronFrequency.trim())
        } else {
            const cronRegex = /^(\*|([0-5]?\d))(\/\d+)?(\s+(\*|([0-5]?\d))(\/\d+)?){4}$/;
            isValid = cronRegex.test(cronFrequency.trim())
        }
        //var cronRegex = /^([0-9\*\/\-\,]+) ([0-9\*\/\-\,]+) ([0-9\*\/\-\,]+) ([0-9\*\/\-\,]+) ([0-9\*\/\-\,A-Z]+(?:\#\d{1,2})?)$/i;
        return isValid ? null : { 'checkCronExpression': true };
    } 
    return null;
}

export const textWithUnderScoreValidation = (control: any): ValidationErrors => {
    let textWithUnderScoreRegex = new RegExp("^[a-zA-Z]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$");
    return textWithUnderScoreRegex.test(control.value) ? null : { 'checkSpecialCharacters': true };
}

export const textValidatorMessage = (error: any, field: FormlyFieldConfig) => {
    return `This field can have only letters, numbers or an underscore( _ ) allowed.No
    spaces allowed. Cannot have two consecutive underscores. Cannot start or end with
    an underscore.`;
}

export const requiredValidatorMessage = (error: any, field: FormlyFieldConfig) => {
    return `${_startCase(_get(field, 'props.label'))} is required.`;
}
export const regexValidatorMessage = (error: any, field: FormlyFieldConfig) => {
    return `${field.formControl.value} is not a valid Regex.`;
}
export function maxlengthValidationMessage(error:any, field: FormlyFieldConfig) {
    return `This value should be less than ${_startCase(_toString(_get(field, 'props.maxLength')))} characters`;
  }
export const validateUniqueMessage= (error: any, field: FormlyFieldConfig) => {
    return `${field.formControl.value} is a duplicate value.`;
}

export const spaceValidatorMessage = (error: any, field: FormlyFieldConfig) => {
    return `${field?.props?.label } cannot start with a space.`;
}
export function regexValidator(control:UntypedFormControl):ValidationErrors {
  // return !control.value || /^(?:(?![\\/])[^\n])+$/g.test(control.value) ? { regexInvalid: true } :  null;
   if (!control.value) {
    return null; // Allow empty input
  }
  let regexString = control.value;
  function hasUnmatchedParentheses(str: string): boolean {
    const openingParentheses = (str.match(/\(/g) || []).length;
    const closingParentheses = (str.match(/\)/g) || []).length;
    return openingParentheses === closingParentheses;
  }

  function hasUnescapedSpecialChars(str: string): boolean {
    return /[^\\](?:[+?|()\[\]{}^$\\])/.test(str);
  }

  try {
    new RegExp(regexString);
    if (!hasUnmatchedParentheses(regexString) || hasUnescapedSpecialChars(regexString)) {
      return { regexInvalid: true };
    }
    return null; 
  } catch (error) {
    return { regexInvalid: true };
  }
}

export function validateUniqueValue(control: any): ValidationErrors | null {
    const subjectName = control.value as string;
  
    if (_isEmpty(subjectName)) {
      return null;
    }

    const parentArray = _get(control, 'parent.parent');
    if (!(parentArray instanceof UntypedFormArray)) {
      return null;
    }

    const parentValue = parentArray.value;
    // Check if the current control is in the list of controls
    
    const controlIndex = _indexOf(_get(control, 'parent.parent.value'), _get(control, 'parent.value'))
    // Filter out the current control from the list and get existing subject names
    const existingSubjectNames = 
    _map(_filter(parentValue, (item: any, index: any) => index !== controlIndex), (item: any) =>
     item[control._fields[0].key]) as string[];
    
    const isUnique = !_includes(existingSubjectNames, subjectName) 
      
    return isUnique ? null : { isUnique: true };
    
} 

export function spaceValidator(control: any): ValidationErrors | null {
    const regex = /^\s/;
    if (regex.test(control.value)) {
        return { spaceValidator: true };
    } else {
        return null;
    }
}
export const getFormlyFieldKeyName = (name) => {
    switch (name) {
        case 'table_select':
            return 'tableSelection'
        case 'column_select':
            return 'columnSelection'
        default:
            return name
    }
}

export const getFormlyFieldReadOnlyValue = (type, mode) => {
    switch(type) {
        case 'INTEGRATION_NAME': 
            return mode === 'edit' ? true : false
        case 'TEMPLATE_NAME': 
            return mode === 'edit' ? true : false
        default: 
            return false
    }
}

export const generateFormlyFieldOptions = (values, field) => {
    const fieldValues = _get(field, 'values', values)
    const fieldLabels = _get(field, 'labels', values)
    return _map(fieldValues, (value, index) => {
        return {
            "value": value,
            "label": fieldLabels[index]
        }
    })
}

export const generateFormlyFieldOptionsFromPossibleValues = (possibleValues, field) => {
    return _map(possibleValues, (possibleValue, index) => {
        return {
            "value": possibleValue.value,
            "label": possibleValue.group
        }
    })
}

export const generateFormlyFieldTimeZoneOptions = (values) => {
    const fieldValues = values
    const fieldLabels = values
    return _map(fieldValues, (value, index) => {
        return {
            "value": value,
            "label": fieldLabels[index]
        }
    })
}

export const disableOtherOptions = (options, selectedValue, field) => {
    return _map(options, (option) => {
        return {
            ...option,
            disabled: selectedValue
              ? selectedValue !== option[field.props.bindValue]
              : false,
          };
      })
}

export const generateFormlyFieldInitHooks = (field: FormlyFieldConfig) => {
    switch (field.key) {
        case 'region': {
            const selectedValue = _first(field.defaultValue)
            const initOptions = field.props.options;
            field.props.options = disableOtherOptions(initOptions, selectedValue, field)
            return (field: FormlyFieldConfig) => {
                return field.parent.formControl.valueChanges.pipe(
                    tap((value) => {
                      const selectedValue = _first(value[_toString(field.key)]);
                      const options = field.props.options
                      field.props.options = disableOtherOptions(options, selectedValue, field)
                    })
                  );
            }
        }

        case 'integration_name':{
            return (field: FormlyFieldConfig) => {
              return field.formControl.valueChanges.pipe(
                tap((value) => {
                  if (!field.validation.show) {
                    field.validation = {
                      show: true,
                    };
                  }
                })
              );
            };
        }
        case 'template_name':{
            return (field: FormlyFieldConfig) => {
              return field.formControl.valueChanges.pipe(
                tap((value) => {
                  if (!field.validation.show) {
                    field.validation = {
                      show: true,
                    };
                  }
                })
              );
            };
        }
        case 'template_list':{
            return (field: FormlyFieldConfig) => {
              return field?.formControl?.valueChanges?.pipe(
                distinctUntilChanged(),
                tap((value) => {
                  if (field.props?.onTemplateChange) {
                    field.props.onTemplateChange(value);
                  }
                })
              );
            };
        }
        default:
            break;
    }
}

export const generateFormlyFieldInitHooksInputType = (fieldType: any, mode?) => {
    switch (fieldType) {

        case 'HISTORY_PICKER': {
            return (parentField: FormlyFieldConfig) => {
                return parentField.options.fieldChanges.pipe(
                    tap( ({field, type, value}) => {
                        const parentProps = _get(field.parent, 'props');
                        if (
                            mode === "edit" &&
                            (field.key === "historyYears" ||
                              field.key === "historyDate" ||
                              _includes(_lowerCase(_toString(field.key)), "date")) &&
                            _get(parentProps, "agreedToReload") !== true &&
                            _get(parentProps, "initialValue") !== value &&
                            value !== null
                          ){
                            let historyYears = _get(_find(_get(field.parent,'fieldGroup'),{key:'historyYears'}),'formControl.defaultValue');
                            let historyDate = _get(_find(_get(field.parent,'fieldGroup'),{key:'historyDate'}),'formControl.defaultValue');
                            if(historyYears != null)
                              _set(parentProps, 'initialValue', historyYears)
                            else if(historyDate != null)
                              _set(parentProps, 'initialValue', historyDate)
                            
                            // `showReloadAlert` is optional in props.
                            // Known unconfigured caller: the integration-edit flow
                            // (/u/edit-studio-source/:dataSourceType/:integrationName/:integrationId/).
                            // If not provided, the reload alert is intentionally skipped.
                            if(typeof parentProps.showReloadAlert === 'function') {
                              parentProps.showReloadAlert(field);
                            }
                        }
                        if((field.key === 'historyYears' || _includes(_lowerCase(_toString(field.key)), 'years')) && value !== null) {
                            const historyDateFormControl: any = field.form.get('historyDate');
                            historyDateFormControl.setValue(null)
                            historyDateFormControl.defaultValue = null;
                            
                        } else if((field.key === 'historyDate' || _includes(_lowerCase(_toString(field.key)), 'date')) && value !== null) {
                            const historyYearsFormControl: any = field.form.get('historyYears');
                            historyYearsFormControl.setValue(null)
                            historyYearsFormControl.defaultValue = null
                        }
                    })
                );
            }
        }
        default:
            break;
    }
}

export const getWrappers = (field: any)  => {
    switch (field.inputElementType) {
        case 'DROPDOWN_LIST':
            return ['dropdown-wrapper']
        case 'RADIO_BUTTON':
            return ['radio-wrapper']
        case 'HISTORY_PICKER':
            return ['radio-wrapper']
        case 'FIXED_VALUES_SLIDER':
            return ['wrapper']
        case 'TEXT':
            return ['common-wrapper']
        default:
            break;
    }
}

export const generateAgGridColumnDefs = (tableData) => {
    return  [
            {
              headerName: 'Profile Id',
              field: 'name',
              sortable: true,
              width: 350,
            },
            {
              headerName: 'Country',
              field: 'category',
              sortable: true,
              width: 350,
            },
            {
              headerName: 'Account Name',
              field: 'isFullLoadSupported',
              // width: 330,
            },
          ]
}

export const modifyInputElementFieldProperties = (inputElements, stepType) => {
    if(stepType === 'TABLE_SELECT') {
       return _map(inputElements, (inputElement) => {
            return  {
                ...inputElement,
                tables: _map(inputElement.tables, table => {
                    return {
                        ...table, 
                        tableName: table.name
                    }
                })
            }
        })
    }
    return inputElements
}

export const getFieldArray = (field, fieldType, mode?, purposeType?)  => {
    switch (fieldType) {
        case 'virtual-scroll-grid':
            return getTableSelectionFieldArray(field, mode, purposeType);
        default:
            break;
    }
}

export const getFieldGroup =(field, fieldType, tableSelect?, mode?, purposeType?) => {
    switch (fieldType) {
        case 'COLUMN_SELECT':
            const columnSelectionData = getColumnSelectionFieldGroup(field, tableSelect, mode, purposeType)
            return columnSelectionData
        case 'ACCORDION_GROUP': 
            const accordionGroupData = getGenericFieldGroup(field, tableSelect, mode, purposeType)
            return accordionGroupData
        case 'HISTORY_PICKER': 
            const historyPickerGroupData = getHistoryPickerFieldGroup(field, mode)
            return historyPickerGroupData
        case 'FREQUENCY_SELECT': 
            const frequencySelectGroupData = getFrequencySelectFieldGroup(field, mode)
            return frequencySelectGroupData
            
        default:
            break;
    }
}

export const getEntitySelectData = (field) =>{
    let columnDefs: any = [];
    let fieldOrder = _get(field, 'fieldOrder');
    let checkboxSelection = false;
    const columns: any = _first(_get(field,'entities'));
    _forEach(columns , (value: string, key: string)=>{
        checkboxSelection = _indexOf(fieldOrder, key) === 0 ? true : false;
        let columnHeader = {
            "headerName": _capitalize(key),
            "checkboxSelection": checkboxSelection, 
            "headerCheckboxSelection": checkboxSelection,
            "field": key,
            "sortable": true,
            "width": 350,
            "filter": "agSetColumnFilter", 
            "menuTabs": ['filterMenuTab'],
            "hide": _includes(fieldOrder, key) ? false : true
        }

        if(typeof value === 'object'){
            columnHeader["cellRenderer"] = 'customizedNonPrimitiveColumn';
        }
        columnDefs.push(columnHeader);
    });

    columnDefs.sort(function(a, b){
        let field1 = a.field;
        let field2 = b.field;

        let index1 = Number.MAX_VALUE;
        let index2 = Number.MAX_VALUE;

        if(fieldOrder.includes(field1)){
            index1 = fieldOrder.indexOf(field1);
        }

        if(fieldOrder.includes(field2)){
            index2 = fieldOrder.indexOf(field2);
        }

        if(index1 < index2){
            return -1;
        }
        else if(index1 > index2){
            return 1;
        }
        return 0;

    });
    let extraFields = _get(field, 'extraFields');
    if(extraFields) {
        _forEach(extraFields, (value: string, key: string) => {
            columnDefs.push({
                "headerName": _capitalize(value),
                "field": value,
                "sortable": true,
                "width": 350,
                "filter": "agSetColumnFilter",
                "menuTabs": ['filterMenuTab'],
                "cellDataType": "text",
                "editable": true,
                "cellRenderer": "customizeCellEditor",
                "cellClassRules": {
                    'editable-cell': function (params) {
                        return params.node.isSelected();
                    },
                    'non-editable-cell': function (params) {
                        return !params.node.isSelected();
                    }
                }
            })
        })
    }
    return columnDefs;
}

export const getTableSelectionFieldArray = (field, mode?, purposeType?) => {
    return {
        "fieldGroupClassName": "form-params-group",
        "fieldGroup": _map(field.tables, (table): FormlyFieldConfig => {
            let selectedTable = _find(field.tableSelection, ['name', table.name]);

            let unnesting = selectedTable ? selectedTable.unnesting : 'null';
            let loadingMode = selectedTable ? selectedTable.loadingMode : 'INHERIT';
            return {
                "fieldGroupClassName": "form-params-group d-flex testing-class flex-gap-8 flex-1",
                // template: table.category,
                className: table.name,
                name: table.name,
                expressions: {
                    hide: (childField) => {
                        return childField.model.name !== table.name
                    }
                },
                props: {
                    label: table.category,
                    isFullLoadSupported: table.isFullLoadSupported,
                    parentTable: _get(table, 'parentTables', []),
                    category: _get(table, 'category', undefined)
                },
                wrappers: ['table-selection-wrapper'],
                "fieldGroup": [
                    {
                        "key": "name",
                        "type": "checkbox",
                        wrappers: [CheckboxWrapperComponent],
                        "className": "studio-configuration-field form-params-field flex-1 column-name items-center",
                        "defaultValue": table.name,
                        "props": {
                            "label": table.name,
                            "appearance": "none",
                            isFullLoadSupported: table.isFullLoadSupported,
                            agreedToReload: false,
                            "tooltipForAutoTable": `${table.name} is required to fetch data for some of the tables you have added.`
                        },
                        "hooks": {
                            onInit: (field: FormlyFieldConfig) => field.formControl.valueChanges.pipe(
                                distinctUntilChanged(),
                                tap((value) => {
                                    field.parent.parent.parent.props.tableDeselectHandler(field.parent.parent, field.parent);
                                }),
                            ),
                        },
                        'expressionProperties': {
                            'props.disabled': (model, formState, field) => {
                                const superParentModel = _get(field, 'parent.parent.parent.props.selectedItemNames');
                                const intersection = _intersection(model.possibleChildren, superParentModel)
                                return !_isEmpty(intersection)
                            }
                        }
                    },
                    {
                        "key": "unnesting",
                        "type": "select",
                        "className": "studio-configuration-field form-params-field flex-1 pb-0",
                        "defaultValue": unnesting,
                        "props": {
                            "label": "Unnesting",
                            "appearance": "outline",
                            "readonly": true,
                            "tooltip": `The default selection has been inherited from the advanced configuration. You can override the default by selecting the unnesting at the table level.`,
                            "options": getSupportedUnnestingOptions(field)
                        },
                        "wrappers": ['dropdown-wrapper'],
                        "hooks": {
                            onInit: (field: FormlyFieldConfig) => field.formControl.valueChanges.pipe(
                                distinctUntilChanged(),
                                tap((value) => {
                                    const superParentProps = _get(field.parent.parent.parent, 'props');
                                    const parentProps = _get(field.parent, 'props');
                                    const tableName = _get(field, 'model.name')
                                    const initialTableModel = _find(superParentProps.initialSelectedTables, {name: tableName})
                                    const defaultValue =  _get(initialTableModel, field.key)
                                    // `showReloadAlert` is optional in props — see HISTORY_PICKER block for full context.
                                    if(mode === 'edit' &&
                                    field.model.name === table.name &&
                                    _get(parentProps, 'agreedToReload') !== true &&
                                    _includes(_get(superParentProps, 'initialSelectedTablesKeys'), _get(field, 'model.name')) &&
                                    defaultValue !== value &&
                                    typeof parentProps.showReloadAlert === 'function') {
                                        parentProps.showReloadAlert(field);
                                    }
                                }),
                            ),
                        },
                    },
                    {
                        "key": "loadingMode",
                        "type": "select",
                        "className": "studio-configuration-field form-params-field flex-1 pb-0",
                        "defaultValue": loadingMode,
                        "props": {
                            "label": "Loading Mode",
                            "appearance": "outline",
                            "readonly": true,
                            "tooltip": `The default selection has been inherited from the advanced configuration. You can override the default by selecting the loading mode at the table level.`,
                            "options": getLoadingModesOptions(field)
                        },
                        "wrappers": ['dropdown-wrapper'],
                        "hooks": {
                            onInit: (field: FormlyFieldConfig) => field.formControl.valueChanges.pipe(
                                distinctUntilChanged(),
                                tap((value) => {
                                    const superParentProps = _get(field, 'parent.parent.parent.props');
                                    const parentProps = _get(field.parent, 'props');
                                    const tableName = _get(field, 'model.name')
                                    const initialTableModel = _find(superParentProps.initialSelectedTables, {name: tableName})
                                    const defaultValue =  _get(initialTableModel, field.key)
                                    // `showReloadAlert` is optional in props — see HISTORY_PICKER block for full context.
                                    if(mode === 'edit' &&
                                    field.model.name === table.name &&
                                    _get(parentProps, 'agreedToReload') !== true &&
                                    _includes(_get(superParentProps, 'initialSelectedTablesKeys'), _get(field, 'model.name')) &&
                                    defaultValue !== value &&
                                    typeof parentProps.showReloadAlert === 'function') {
                                        parentProps.showReloadAlert(field);
                                    }
                                }),
                            ),
                        },
                    }
                ]
            }
        })
    }
}

export const getLoadingModesOptions = ({supportedLoadingModesValues, supportedLoadingModes}) => {
    return _map(supportedLoadingModesValues, (value, index, key) => {
        return {
            "value": value,
            "label": supportedLoadingModes[index]
        }
    })
}

export const getSupportedUnnestingOptions = ({supportedUnnestingValues, supportedUnnesting}) => {
    return _map(supportedUnnestingValues, (value, index, key) => {
        return {
            "value": value,
            "label": supportedUnnesting[index]
        }
    })
}

export const getGenericFieldGroup = (field, tableSelect?, mode?, purposeType?) => {
    return generateFormlyFields(field.childInputElements, tableSelect, mode, purposeType)
}

export const getColumnSelectionFieldGroup = (field, tableSelect, mode?, purposeType?) => {

    return _map(field.columns, (column, key) => {
        let unnesting = null, loadingMode = null;

        if(mode === 'edit'){
            let currentColumn = _find(tableSelect, ['name', key]);

            unnesting = currentColumn ? currentColumn.unnesting : null;
            loadingMode = currentColumn ? currentColumn.loadingMode : null;
        }
        return {
            "key": key,
            "type": 'column-selection',
            "props": {
              "gridOptions": {
                "columnDefs": [
                  {
                    "headerName": 'Column name',
                    "checkboxSelection": true,
                    "headerCheckboxSelection": true,
                    "field": 'name',
                    "sortable": true,
                    "width": 350,
                  },
                  {
                    "headerName": 'Unnesting',
                    "field": 'unnesting',
                    "sortable": true,
                    "width": 350,
                  },
                  {
                    "headerName": 'Primary Key',
                    "field": 'primary',
                    // "width": 330,
                  },
                  {
                    "headerName": 'checked',
                    "field": 'checked',
                    "hide": true
                  },
                ],
              },
              "isGreenTickRequired": false,
              "agreedToReload": false,
              "advancedUnnestingValue": unnesting,
              "advancedLoadingMode":  loadingMode,
              "agreedToNewColumnReload" : false,
              "newTable": checkIsTableNew(key, _get(field, 'old_table_selection')),
            },
            "fieldArray": {
              "fieldGroup": [
                {
                  "key": 'checked',
                  "defaultValue": false,
                },
                {
                  "key": 'name',
                  "type": 'input',
                  "className": 'flex-2 column-selection-cell',
                  
                  "props": { "readonly": true, "appearance": '', },
                },
                {
                  "type": 'select',
                  "key": 'unnesting',
                  "className": 'flex-2 column-selection-unnesting-cell',
                  "defaultValue": unnesting || 'null',
                  "props": {
                    "label": 'Unnesting',
                    "appearance": 'outline',
                    "options": getSupportedUnnestingOptions(field),
                    "disabled": true
                  },
                  expressions: {
                    hide: (field) => {
                      return field.model.isRecord === false
                    }
                   },
                   "hooks": {
                        onInit: (field: FormlyFieldConfig) => field.formControl.valueChanges.pipe(
                            distinctUntilChanged(),
                            tap((value) => {
                                const isNewTable = _get(field.parent.parent.props, 'newTable');
                                if(!isNewTable && mode === 'edit'){
                                    const superParentProps = _get(field, 'parent.parent.parent.props');
                                    const parentProps = _get(field, 'parent.parent.props');
                                    const selectedColumnName = _get(field, 'model.name');
                                    const selectedTableName = _get(field.parent.parent, 'key');
                                    const initialColumnModel = _find(_get(superParentProps.columnSelection, selectedTableName), {name: selectedColumnName})
                                    const defaultValue =  _get(initialColumnModel , field.key)
                                    // `showReloadAlert` is optional in props — see HISTORY_PICKER block for full context.
                                    if(field.model.name === selectedColumnName && _get(parentProps, 'agreedToReload') !== true && !_isEmpty(initialColumnModel) && defaultValue !== value &&
                                        typeof parentProps.showReloadAlert === 'function') {
                                        parentProps.showReloadAlert(field);
                                    }
                                }
                            }),
                        ),
                    },
                },
                {
                  "type": 'checkbox',
                  "className": 'flex-1',
                  "key": 'primary',
                  "wrappers": [CheckboxWrapperComponent],
                  "props": {
                    // "label": 'primary',
                    "disabled": true,
                    "tooltipForPrimary": "Primary key is mandatory for upsert."
                  },
                  "hooks": {
                    onInit: (field: FormlyFieldConfig) => field.formControl.valueChanges.pipe(
                        distinctUntilChanged(),
                        tap((value) => {
                            const parentProps = _get(field, 'parent.parent.props');
                            const superParentProps = _get(field, 'parent.parent.parent.props');
                            const isNewTable = _get(parentProps, 'newTable');
                            if(!isNewTable && mode === 'edit'){
                                const selectedColumnName = _get(field, 'model.name');
                                const selectedTableName = _get(field.parent.parent, 'key');
                                const initialColumnModel = _find(_get(superParentProps.columnSelection, selectedTableName), {name: selectedColumnName})
                                const defaultValue =  _get(initialColumnModel , field.key)
                                // `showReloadAlert` is optional in props — see HISTORY_PICKER block for full context.
                                if(field.model.name === selectedColumnName && _get(parentProps, 'agreedToReload') !== true && !_isEmpty(initialColumnModel) && defaultValue !== value &&
                                    typeof parentProps.showReloadAlert === 'function') {
                                    parentProps.showReloadAlert(field);
                                }
                            }
                            superParentProps.enableSubmitBtn(field)
                        }),
                    ),
                 },
                },
                
              ],
            },
          }
    })
}

export const checkIsTableNew = (key, old_table_selection) => {
    return _find(old_table_selection, { name: key}) ? false : true; 
}

export const getHistoryYearsDefaultValue = (field, mode) => {
    const isHistoryDateSet = _get(field, 'historyDate');
    if(isHistoryDateSet) {
        return null
    } else if(mode === 'create'){
        return field.historyYears || 1
    } else {
        return field.historyYears
    }
}
export const getHistoryYearsRequiredProperty = (field, mode) => {
    const isHistoryDateSet = _get(field, 'historyDate');
    if(isHistoryDateSet) {
        return false
    } else if(mode === 'create'){
        return true
    } else {
        return false
    }
}

export const getDefaultValue = (field) => {
    const fieldInputType = _get(field, 'inputElementType');
    if(fieldInputType === "FREQUENCY_SELECT") {
        return undefined
    } 
    return _get(field, 'selection')
}

export const getFrequencySelectFieldGroup = (field, mode?) => {
    return [
        {
            key: FREQUENCY_KEYS.PERIODIC_FREQUENCY,
            type: 'ngx-slider',
            defaultValue: _get(field, 'selection.periodicFrequency') || "1",
            className: 'studio-configuration-field w-200',
            props: {
                label: "Presets",
                thumbLabel: true,
                tickInterval: 1,
                displayWith: formatFormlySliderFieldLabel,
                step: 1,
                min: 1,
                max: _max(_map(field.values, _toNumber)),
                sliderOptions: getNGXSliderProps(field),
                value: "presets",
                isCurrentlyVisible: false
            },
            // expressions: {
            //     hide: (field) => {
            //       return !field.props.isCurrentlyVisible;
            //     },
            // },
            hooks: {
                onInit: (field: FormlyFieldConfig) => {
                    const cronField = field.form.get(FREQUENCY_KEYS.CRON_FREQUENCY_TYPE);
                    if(cronField) {
                        cronField.valueChanges.pipe(
                            tap((value) => {
                                const periodicField = field.form.get(FREQUENCY_KEYS.PERIODIC_FREQUENCY);
                                if (periodicField && periodicField.value !== '1' && _get(value, FREQUENCY_KEYS.CRON_FREQUENCY) !== "") {
                                    _set(periodicField, 'defaultValue',  "1");
                                    periodicField.patchValue("1");
                                    periodicField.setValue("1");
                                }
                                let cronFreqField = _get(field, 'parent.fieldGroup[1].fieldGroup[0]')
                                const isValid = cronValidator(_get(cronFreqField, 'formControl'), cronFreqField);
                                const cronExpression = _get(value, FREQUENCY_KEYS.CRON_FREQUENCY);
                                _set(cronFreqField, 'props.cronExplainer', _isNull(isValid) && cronExpression !== "" ? cronstrue.toString(cronExpression) : null)
                            })
                        ).subscribe()
                    }
                    field.formControl.valueChanges.pipe(
                        tap((value) => {
                            const cronFrequencyPath = getNestedFormControlPath(
                                FREQUENCY_KEYS.CRON_FREQUENCY_TYPE,
                                FREQUENCY_KEYS.CRON_FREQUENCY
                              );
                            const cronField = field.form.get(cronFrequencyPath);
                            if (cronField && _get(cronField, 'value') !== "" && value !== "1") {
                                _set(cronField, 'defaultValue',  "");
                                cronField.patchValue("");
                                cronField.setValue("");
                            }
                        })
                    ).subscribe()
                }
            },
        },
        {
            key: FREQUENCY_KEYS.CRON_FREQUENCY_TYPE,
            type: "cron-frequency",
            className: "cron-frequency-container" ,
            props: {
                required: true,
                type: "text",
                label: "Cron",
                value: "cron",
                showGenerateExpressionFields: false,
                cronFlavor: 'quartz',
                isCurrentlyVisible: false
            },
            // expressions: {
            //     hide: (field) => {
            //       return !field.props.isCurrentlyVisible;
            //     },
            // },
            fieldGroup: [
                {
                    key: FREQUENCY_KEYS.CRON_FREQUENCY,
                    type: "input",
                    className: "studio-configuration-field w-200 cron-frequency",
                    defaultValue: _get(field, 'selection.cronFrequency') || "",
                    props: {
                        label: "Cron Expression",
                        placeholder: "Enter your cron expression",
                        appearance: "outline"
                    },
                    validators: {
                        validation: ['checkCronExpression'],
                    },
                    validation: {
                        show: true
                    }
                },
                {
                    key: FREQUENCY_KEYS.TIMEZONE_FOR_CRON_FREQUENCY,
                    type: "ng-select",
                    className: "studio-configuration-field w-200 timezone-dropdn",
                    defaultValue: _get(field, 'selection.timeZoneForCronFrequency') || "UTC",
                    props: {
                        label: "Select the timezone",
                        placeholder: "Select the timezone",
                        options: generateFormlyFieldTimeZoneOptions(_get(field, 'timeZoneList')),
                        appearance: "outline",
                        bindValue: "value",
                        bindLabel: "label",
                        isClearable: false,
                        searchable: true
                    },
                }
            ]
        }
    ]
}
 


export const getHistoryPickerFieldGroup = (field, mode?) => {
    return[
        {
            'key': 'historyYears',
            'type': 'history-years',
            'defaultValue': getHistoryYearsDefaultValue(field, mode),
            "props": {
                    label: field.label,
                    placeholder: _get(field, 'placeholder') || _get(field, 'label'),
                    appearance: 'outline',
                    required: getHistoryYearsRequiredProperty(field, mode), //mode === 'create' ? true : false,
                    options: [
                        { value: 1, label: '1 \n Year' },
                        { value: 2, label: '2 \n Years' },
                        { value: 3, label: '3 \n Years' },
                        { value: 4, label: '4 \n Years' },
                    ],
            },
            'hooks': {
                onInit: (field: FormlyFieldConfig) => {
                    return field.form.get('historyDate').valueChanges.pipe(
                        tap((value) => {
                            field.defaultValue = null;
                            field.props.required = false;
                        })
                    )
                }
            },
        },
        {
            'template': 'Or'
        },
        {
        'key': 'historyDate',
        'type': 'datepicker',
        'className': 'history_datepicker',
        'defaultValue': parseHistoryValue(field.historyDate),
        'hooks': {
            onInit: (field: FormlyFieldConfig) => {
                return field.form.get('historyYears').valueChanges.pipe(
                    tap((value) => {
                        field.defaultValue = null;
                    })
                )
            }
        },
        "props": {
                label: field.label,
                placeholder: _get(field, 'placeholder') || _get(field, 'label'),
                thumbLabel: true,
                appearance: 'outline',
                required: false,
                datepickerOptions: {
                    min: getXYearsAgo(20),
                    max: getCurrentDate(),
                }
            }
        },
    ]
}

export const deriveFormlyFieldPropsType = (fieldType) => {
    return formlyFieldPropsTypeMap[fieldType] || undefined
}

export const fieldTypeCSSMap = {
    "INTEGRATION_NAME": "studio-configuration-field w-72-5 integration_name",
    "TEXT": "studio-configuration-field",
    "RADIO_BUTTON": "studio-configuration-field w-72-5",
    "FIXED_VALUES_SLIDER": "studio-configuration-field w-200",
    "HISTORY_PICKER": "studio-configuration-field w-72-5",
    "ACCORDION_GROUP": "studio-configuration-field w-200",
    "DROPDOWN_LIST": "studio-configuration-field w-72-5",
    "start_datetime": "studio-configuration-field w-72-5",
    "TEMPLATE_NAME": "studio-configuration-field w-72-5 template_name",
    "TABLE_SELECT": 'w-full',
    "COLUMN_SELECT": 'w-full',
    "CHECKBOX": "studio-configuration-field w-72-5",
}

export const fieldGroupCSSMap = {
    "HISTORY_PICKER": 'history-picker-container',
    "FREQUENCY_SELECT": 'frequency-select-container'
}

export const generateFormlyFields = (fields, tableSelect?, mode?, purposeType?) => {
    return _map(fields, (field) => {
        const formlyField: FormlyFieldConfig = {
            className: fieldTypeCSSMap[field.inputElementType] || 'studio-configuration-field',
            ...(!isFormlyFieldKeyNotRequired(field.inputElementType) && {
                key: getFormlyFieldKeyName(field.id)
            }),
            ...(!isFormlyFieldKeyNotRequired(field.inputElementType) && {
                name: getFormlyFieldKeyName(field.id)
            }),
            ...(isFormlyFieldTypeRequired(field.inputElementType) && {
                type: datonStudioFormlyFieldMap[field.inputElementType],
            }),
            defaultValue: getDefaultValue(field),
            props: {
                label: field.label,
                ...(isFormlyFieldReadOnlyRequired(field.inputElementType) && {
                    readonly: getFormlyFieldReadOnlyValue(field.inputElementType, mode)
                }),
                ...({maxLength: setMaxFieldLength(field)}),
                placeholder: _get(field, 'placeholder') || _get(field, 'label'),
                required: setRequiredProperty(field),
                description: changeDescription(field.helpText),
                ...(field.addTag && {addTag: field.addTag}),
                ...(field.searchable && {searchable: field.searchable}),
                ...(isFormlyFieldOptionRequired(field.inputElementType) &&  {
                    options: generateFormlyFieldOptions(field.labels, field)
                }),
                ...(deriveFormlyFieldPropsType(field.inputElementType) && {
                    type: deriveFormlyFieldPropsType(field.inputElementType)
                }),
                ...((!_isUndefined(field.columnSelection) && !_isEmpty(field.columnSelection)) && {
                    columnSelection: field.columnSelection
                }),
                "appearance": datonStudioFormlyFieldAppearanceMap[field.inputElementType],
                "disabled": (mode == 'edit' && field.editable === false) || false,
                ...(isFormlyFieldModeRequired(field.inputElementType) && { "mode": mode })
            },
            ...(isFormlyFieldWrapperRequired(field.inputElementType) && !isFormlyFieldWrapperReqforAccordion(field.id) && {
                wrappers: getWrappers(field)
            }),
            ...(isFormlyFieldWrapperReqforAccordion(field.id) && {
                wrappers: ['accordion-wrapper']
            })
        }
        if(isEntityType(formlyField.type)){
            formlyField.props.gridOptions = {}
            formlyField.props.gridOptions.columnDefs = getEntitySelectData(field);
            formlyField.props.rowData = _get(field, 'entities');
            formlyField.props.prevSelection = field.selection;
            formlyField.props.maxAllowedEntities = field.maxAllowedEntities;
            formlyField.props.extraFields = _get(field, 'extraFields');
            formlyField.props.requiredExtraFields = _get(field, 'requiredExtraFields', []);
        }

        if(isFormlyFieldHooksRequired(formlyField.name) || isFormlyFieldHooksRequiredInputType(field.inputElementType)) {
            formlyField['hooks'] = {}
            formlyField['hooks'].onInit = isFormlyFieldHooksRequired(formlyField.name)? generateFormlyFieldInitHooks(formlyField): generateFormlyFieldInitHooksInputType(field.inputElementType,mode)
        }

        if(mode === 'edit' && isFormlyFieldReloadRequired(field.inputElementType)) {
            formlyField.props.inputElementType = field.inputElementType
            formlyField.props.agreedToReload = false;
        }

        if(isFormlyFieldMultiplePropsRequired(formlyField.type) && !fieldsNotRequireMultiple(field.inputElementType)) {
            formlyField.props.multiple = true;
        }

        if(isFormlyFieldBindValuePropsRequired(formlyField.type)) {
            formlyField.props.bindValue = 'value';
        }

        if(isAgGridColumnDefsRequired(formlyField.type)) {
            formlyField.props.gridOptions = {}
            formlyField.props.gridOptions.columnDefs = generateAgGridColumnDefs(_get(field, 'tables'));
        }

        if(isAgGridRowDataRequired(formlyField.type)) {
            formlyField.props.rowData = _get(field, 'tables');
        }


        if(isFormlyFieldArrayRequired(formlyField.type)) {
            formlyField.fieldArray = getFieldArray(field, formlyField.type, mode, purposeType);
        }

        if(isFormlyFieldGroupRequired(field.inputElementType)) {
            formlyField.fieldGroupClassName = fieldGroupCSSMap[field.inputElementType],
            formlyField.fieldGroup = getFieldGroup(field, field.inputElementType, tableSelect, mode, purposeType);
        }

        if(isFormlyDatePickerOptionsRequired(field.inputElementType)) {
            formlyField.props.datepickerOptions = {
                min: getXYearsAgo(20),
                max: getCurrentDate(),
            }
        }

        if(isFormlySliderPropsRequired(field.inputElementType)) {
            formlyField.props.thumbLabel = true;
            formlyField.props.tickInterval = 1;
            formlyField.props.displayWith =  formatFormlySliderFieldLabel;
            formlyField.props.step = 1;
            formlyField.props.min =  1;
            formlyField.props.max = _max(_map(field.values, _toNumber));
            formlyField.props.sliderOptions = getNGXSliderProps(field) 
        }

        if(isFormlyFieldIntegrationNamesPropRequired(field.inputElementType)) {
            formlyField.props.existingIntegrationNames = field.alreadyUsedIntegrationNames;
        }

        if(isFormlyFieldTemplateNamesPropRequired(field.inputElementType)){
            formlyField.props.existingTemplateNames = field.alreadyUsedTemplateNames;
        }

        if(isFormlyFieldValidationRequired(field.inputElementType) && (mode === 'create' || mode === 'attach' || mode === 'clone')) {
            formlyField.validators = {
                validation: getFormlyFieldValidatorTypes(field.inputElementType, mode),
            }
            formlyField.validation = {
                show: mode === 'clone' ? true : false,
            };
        }
        return formlyField
    })
}

export const getFormlyFieldValidatorTypes = (fieldType, mode?) => {
    if(mode === 'create' || mode === 'attach')
      return ['existingIntegrationName','checkSpecialCharacters', 'existingTemplateName']
    else if(mode === 'clone')
      return ['checkClonedIntegrationName','existingIntegrationName','checkSpecialCharacters']
}

export const getStudioSessionKey = (userId, sourceId, type) => {
    return `${userId}_${sourceId}_${type}`
}

export const setRequiredProperty = (field) => {
    if(field.inputElementType === 'HISTORY_PICKER') {
        return false
    }
    return field.required || false
}

export const setMaxFieldLength = (field) => {
    if(field.inputElementType === 'INTEGRATION_NAME') {
        return field.maxLength || 50
    }
    if(field.inputElementType === 'TEMPLATE_NAME') {
        return field.maxLength || 50
    }
    else if(field.inputElementType === 'TEXT' && field.id === 'description') {
        return field.maxLength || 300
    }
    else if(field.inputElementType === 'TEXT'){
        return field.maxLength || 1000
    }
    
}

export const getOAuthUrl = (authProperties, pkceProperties?) => {
    const { authorizationEndpoint, 
            authorizationQueryParams,
            authorizationHeaderParams,
            authorizationRequestBody,
            authorizationRequestBodyType,
            authorizationRequestMethod  } = authProperties
    console.log(authorizationQueryParams)
    const params = new URLSearchParams();

    _forEach(authorizationQueryParams, (value, key) => {
        params.set(key, value);
    });

    params.set('state', getUuid());
    if(!_isUndefined(pkceProperties)) {
        params.set('code_challenge', pkceProperties.codeChallenge)
        params.set('code_challenge_method', pkceProperties.codeChallengeMethod)
    }

    const url = `${authorizationEndpoint}?${params.toString()}`;

    return url

}

export const changeDescription =  (desc) => {
    const filterPipe = new InterpolatePipe();
    if(desc && _includes(desc,'***')){
      let helpText = desc;
      let urlRegex = new RegExp(/(\bhttps:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
      let stepHelpText = helpText.replace(urlRegex,'');
      let linkReplacementText = stepHelpText.substring(stepHelpText.indexOf('*'),stepHelpText.lastIndexOf('*')+1);
      let clickText = (_indexOf(helpText, '*') == 0 || _indexOf(helpText, '.') + 2 == _indexOf(helpText, '*')) ? 
      _startCase(linkReplacementText) : 
      _lowerCase(linkReplacementText);
      let stepHelpTextURL = '<a href="' + helpText.match(urlRegex) + '" target="_blank">' + clickText + '</a>';
      return filterPipe.transform(stepHelpText, linkReplacementText, stepHelpTextURL);
    }
    else
    return desc;
  }

export const testHtmlRegex = (text) => {
    let htmlRegex = new RegExp("<([A-Za-z][A-Za-z0-9]*)\\b[^>]*>(.*?)</\\1>");
    return htmlRegex.test(text)
}

export const showErrorMessage = (field) => {
    return (field.formControl && field.formControl.invalid && field.formControl.touched)
}

export const isValidURL = (url) => {
    try {
        const urlObj = new URL(url);
        return true;
    } catch (error) {
        return false;
    }
}

export async function getHmacSHA256(key, message) {
    const encoder = new TextEncoder();
    const encodedKey = encoder.encode(key);
    const encodedMessage = encoder.encode(message);

    const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        encodedKey,
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
    );

    const signature = await window.crypto.subtle.sign(
        'HMAC',
        cryptoKey,
        encodedMessage
    );

    return byteArrayToHex(new Uint8Array(signature));
}
  
function byteArrayToHex(byteArray) {
    return Array.from(byteArray, (byte) => byte.toString().padStart(2, '0')).join('');
}

/**

* @name formatDateCustom
* @description dateInMilliSeconds converts to format "Aug 10, 2023"

*/
export const formatDateCustom = (dateInMilliSeconds: number | null | undefined): string => {
    if (dateInMilliSeconds == null) {
        return '';
    }

    const currentDate = new Date(dateInMilliSeconds);

    // Check if the date is valid
    if (isNaN(currentDate.getTime())) {
        return 'Invalid Date';
    }

    // Format the date using Intl.DateTimeFormat
    const formattedDate = currentDate?.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });

    return formattedDate ?? ''; // Return formatted date "Aug 10, 2023" or an empty string if formatting fails
};

/**

* @name formatDateUsingUTCSeconds
* @description epoch converts to format "Aug 10, 2023"

*/
export const formatDateUsingUTCSeconds = (utcSeconds) => {
    let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds);
    let formattedDate = new Intl.DateTimeFormat('en-US', { month: "short" , day: "numeric", year : "numeric" }).format(d)
    return formattedDate; // "Aug 10, 2023"
}

/**

* @name getBillingCycle
* @description get Billing Cycle from Billing Days

*/
export const getBillingCycle = (billingDays, passTrueForDayFalseForDaily, strikeOutPrice?) => {
    console.log(strikeOutPrice)
    const billingCycles = {
        1: ['day', 'daily'],
        7: ['week', 'weekly'],
        14: ['fortnight', 'fortnightly'],
        30: ['month', 'monthly'],
        90: ['quarter', 'quarterly'],
        365: ['year', 'yearly', 'month'],
    };
    const cycleOptions = billingCycles[billingDays];
    if (!cycleOptions) return '';

    if (passTrueForDayFalseForDaily) {
        return strikeOutPrice && cycleOptions.length > 2 ? cycleOptions[2]: cycleOptions[0]; 
    } else {
        // Use the third option if strikeOutPrice is true and it exists, otherwise default to the second option
        return strikeOutPrice && cycleOptions.length > 2 ? cycleOptions[2] : cycleOptions[1];
    }
};

/**

* @name isJsonValid
* @description Checks string passed is a valid JSON object or not

*/
export function isJsonValid(item) {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
        value = JSON.parse(value);
    } catch (e) {
        return false;
    }

    return typeof value === "object" && value !== null;
}

/**

* @name getFromDescription
* @description Checks string passed is a valid JSON string or not and returns the value of the key passed or ''

*/
export function getFromDescription(objectAsString : string, key: 'planName' | 'planHeading' | 'bulletPoints'){
    if(isJsonValid(objectAsString)){
        let obj =  JSON.parse(objectAsString);
        return _get(obj, key, '');
    } else if(typeof objectAsString == 'string' && key == 'planName' ) {
        return objectAsString;
    } else {
        return '';
    }
}


export function getStartDateMidnightUTC(dateInMilliseconds = new Date().getTime(), previousMonthsCount:number = 0 ){
    const d = new Date(dateInMilliseconds);
    console.log('fromdateInUTCBefore', d.toUTCString())
    d.setUTCHours(0);
    d.setUTCMinutes(0);
    d.setUTCSeconds(0);
    d.setUTCMilliseconds(0);
    d.setUTCFullYear(d.getFullYear(), d.getMonth() - previousMonthsCount);
    console.log('fromdateInUTC', d.toUTCString())
    return d.getTime(); // get 3 months old in milliseconds of utc date at 00:00:00 GMT hrs: mins: seconds 
  }

  export function getEndDateMidgnightUTC(dateInMilliseconds = new Date().getTime()){
    const d = new Date(dateInMilliseconds);
    console.log('todateInUTCBefore', d.toUTCString())
    d.setUTCHours(0);
    d.setUTCMinutes(0);
    d.setUTCSeconds(0);
    d.setUTCMilliseconds(0);
    d.setUTCHours(23);
    d.setUTCMinutes(59);
    d.setUTCSeconds(59);
    d.setUTCMilliseconds(999);
    console.log('todateInUTC', d.toUTCString())
    return d.getTime(); // today eod in utc date at 23:59:59 GMT hrs: mins: seconds
  }

  /**

* @name getDaysCount
* @description pass startMillis as future date in milliseconds, endMillis as today or old date in milliseconds

*/
  export function getDaysCount(startMillis, endMillis = new Date().getTime()){
    return Math.round((startMillis - endMillis)/ (24 * 60 * 60 * 1000));
  }

  
  /**
    * @name nFormatter
    * @description nFormatter(100000000, 1) = 100M nFormatter(299792458, 1) = 299.8M

  */
  export function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }
  
  /*
   * Tests
   */
//   const tests = [
//     { num: 0, digits: 1 },
//     { num: 12, digits: 1 },
//     { num: 1234, digits: 1 },
//     { num: 100000000, digits: 1 },
//     { num: 299792458, digits: 1 },
//     { num: 759878, digits: 1 },
//     { num: 759878, digits: 0 },
//     { num: 123, digits: 1 },
//     { num: 123.456, digits: 1 },
//     { num: 123.456, digits: 2 },
//     { num: 123.456, digits: 4 }
//   ];
//   tests.forEach(function(test) {
//     console.log("nFormatter(" + test.num + ", " + test.digits + ") = " + nFormatter(test.num, test.digits));
//   });

export const hasAdminAccess = (userRole: string[] | string) => {
    return !_isEmpty(_intersection(_castArray(userRole), NS_AdminService.ALLOWED_ADMIN_ROLES))
}

export const hasCStudioAccess = (userRole: string[] | string) => {
    return !_isEmpty(_intersection(_castArray(userRole), NS_ConnectorStudioService.ALLOWED_CSTUDIO_ROLES))
}

export const getObjectKeyOrString = (value, key) => {
    if (_isPlainObject(value)) {
        return value[key] ? value[key] : 'Key not found';
    } else if (_isString(value)) {
        return value
    } else {
        return undefined;
    }
}

export const svgMenuMap = {
  dashboards: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M8.75 13A2.25 2.25 0 0 1 11 15.25v3.5A2.25 2.25 0 0 1 8.75 21h-3.5A2.25 2.25 0 0 1 3 18.75v-3.5A2.25 2.25 0 0 1 5.25 13h3.5zm10 0A2.25 2.25 0 0 1 21 15.25v3.5A2.25 2.25 0 0 1 18.75 21h-3.5A2.25 2.25 0 0 1 13 18.75v-3.5A2.25 2.25 0 0 1 15.25 13h3.5zm-10 1.5h-3.5a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75zm10 0h-3.5a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75zM8.75 3A2.25 2.25 0 0 1 11 5.25v3.5A2.25 2.25 0 0 1 8.75 11h-3.5A2.25 2.25 0 0 1 3 8.75v-3.5A2.25 2.25 0 0 1 5.25 3h3.5zm10 0A2.25 2.25 0 0 1 21 5.25v3.5A2.25 2.25 0 0 1 18.75 11h-3.5A2.25 2.25 0 0 1 13 8.75v-3.5A2.25 2.25 0 0 1 15.25 3h3.5zm-10 1.5h-3.5a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75zm10 0h-3.5a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75z"/></svg>`,
  sources: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M19.49 5.57a5.999 5.999 0 0 1-1.893 8.962c-.649.351-1.43.135-1.952-.386l-5.79-5.791c-.522-.522-.738-1.303-.388-1.952A5.999 5.999 0 0 1 18.43 4.51l2.29-2.29a.75.75 0 1 1 1.061 1.06l-2.29 2.29zm-2.017 7.263a4.5 4.5 0 1 0-6.306-6.306c-.266.349-.186.833.125 1.143l5.037 5.038c.31.31.795.391 1.144.125zM3.28 21.78l2.29-2.29a5.999 5.999 0 0 0 8.962-1.893c.351-.649.135-1.43-.387-1.952l-5.79-5.79c-.522-.522-1.303-.738-1.952-.388A5.999 5.999 0 0 0 4.51 18.43l-2.29 2.29a.75.75 0 1 0 1.06 1.061zm4.39-10.488 5.038 5.038c.31.31.39.794.125 1.143a4.5 4.5 0 1 1-6.306-6.306c.349-.266.833-.186 1.143.125z"/></svg>`,
  destination: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M9.485 2.132C8.251 2.694 7.2 3.592 7.2 4.8v3.616a11.001 11.001 0 0 1 1.2 0V6.838c.326.242.696.453 1.085.63 1.289.585 3.027.932 4.915.932s3.627-.347 4.916-.933c.389-.176.76-.386 1.084-.63V16.8c0 .448-.427 1.05-1.581 1.575-1.1.5-2.662.825-4.418.825v.6c0 .207-.022.408-.062.6h.061c1.888 0 3.627-.347 4.916-.932 1.234-.562 2.284-1.46 2.284-2.668v-12c0-1.208-1.05-2.106-2.284-2.668-1.29-.585-3.028-.932-4.916-.932-1.888 0-3.626.347-4.915.932zm.497 4.243C8.828 5.85 8.4 5.248 8.4 4.8c0-.449.428-1.05 1.582-1.575 1.1-.5 2.661-.825 4.418-.825 1.757 0 3.32.325 4.419.825C19.973 3.749 20.4 4.35 20.4 4.8c0 .448-.427 1.05-1.581 1.575-1.1.5-2.662.825-4.419.825-1.757 0-3.318-.325-4.418-.825zM8.4 9.618c.364.023.717.065 1.056.125.48.086.932.209 1.344.362 1.447.538 2.4 1.455 2.4 2.495 0 1.657-2.417 3-5.4 3-2.982 0-5.4-1.343-5.4-3 0-1.544 2.1-2.816 4.8-2.982a9.79 9.79 0 0 1 1.2 0zm4.711 10.727c-.462 1.396-2.664 2.454-5.31 2.454-2.983 0-5.4-1.343-5.4-3v-4.734c.305.275.647.51.998.705 1.187.66 2.746 1.03 4.401 1.03 1.656 0 3.215-.37 4.401-1.03a5.466 5.466 0 0 0 1.001-.707l-.002 4.085v.651c0 .187-.03.37-.089.546z"/></svg>`,
  users: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM17 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-2.752 13.038c.703.285 1.604.462 2.753.462 2.282 0 3.586-.697 4.297-1.558.345-.418.52-.84.61-1.163a2.728 2.728 0 0 0 .093-.573v-.027A2.179 2.179 0 0 0 19.822 14H14.18c-.028 0-.055 0-.082.002.394.41.68.925.816 1.498h4.908c.372 0 .674.299.679.669a1.236 1.236 0 0 1-.04.212 1.6 1.6 0 0 1-.32.605c-.35.426-1.172 1.014-3.14 1.014-.98 0-1.676-.146-2.17-.345-.108.4-.286.883-.583 1.383zM4.25 14A2.25 2.25 0 0 0 2 16.25v.278a2.073 2.073 0 0 0 .014.208 4.487 4.487 0 0 0 .778 2.07C3.61 19.974 5.172 21 8 21c2.828 0 4.39-1.025 5.208-2.195a4.484 4.484 0 0 0 .778-2.07 2.992 2.992 0 0 0 .014-.207v-.278A2.25 2.25 0 0 0 11.75 14h-7.5zm-.75 2.507v-.257a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v.257l-.007.08a2.986 2.986 0 0 1-.514 1.358C11.486 18.65 10.422 19.5 8 19.5s-3.486-.85-3.98-1.555a2.986 2.986 0 0 1-.513-1.358 1.527 1.527 0 0 1-.007-.08z"/></svg>`,
  settings: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M12.013 2.25c.734.008 1.465.093 2.182.253a.75.75 0 0 1 .582.649l.17 1.527a1.384 1.384 0 0 0 1.927 1.116l1.4-.615a.75.75 0 0 1 .85.174 9.793 9.793 0 0 1 2.205 3.792.75.75 0 0 1-.272.825l-1.241.916a1.38 1.38 0 0 0 0 2.226l1.243.915a.75.75 0 0 1 .272.826 9.798 9.798 0 0 1-2.204 3.792.75.75 0 0 1-.848.175l-1.407-.617a1.38 1.38 0 0 0-1.926 1.114l-.17 1.526a.75.75 0 0 1-.571.647 9.518 9.518 0 0 1-4.406 0 .75.75 0 0 1-.572-.647l-.169-1.524a1.382 1.382 0 0 0-1.925-1.11l-1.406.616a.75.75 0 0 1-.85-.175 9.798 9.798 0 0 1-2.203-3.796.75.75 0 0 1 .272-.826l1.243-.916a1.38 1.38 0 0 0 0-2.226l-1.243-.914a.75.75 0 0 1-.272-.826A9.793 9.793 0 0 1 4.88 5.355a.75.75 0 0 1 .85-.174l1.4.615a1.387 1.387 0 0 0 1.93-1.118l.17-1.526a.75.75 0 0 1 .583-.65 10.72 10.72 0 0 1 2.201-.252zm0 1.5a9.135 9.135 0 0 0-1.354.117l-.11.977A2.886 2.886 0 0 1 6.527 7.17l-.899-.394A8.293 8.293 0 0 0 4.28 9.092l.798.587a2.881 2.881 0 0 1 .001 4.643l-.799.588c.32.842.776 1.626 1.348 2.322l.905-.397a2.882 2.882 0 0 1 4.017 2.318l.109.984c.89.15 1.798.15 2.688 0l.109-.984a2.88 2.88 0 0 1 4.019-2.322l.904.396a8.299 8.299 0 0 0 1.348-2.318l-.798-.588a2.88 2.88 0 0 1-.001-4.643l.797-.587a8.293 8.293 0 0 0-1.348-2.317l-.897.393a2.884 2.884 0 0 1-4.023-2.324l-.109-.976a8.991 8.991 0 0 0-1.334-.117zm-.012 4.5a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zm0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5z"/></svg>`,
  error_Circle: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path d="M6.99935 1.1665C10.2211 1.1665 12.8327 3.77867 12.8327 6.99984C12.8327 10.221 10.2211 12.8332 6.99935 12.8332C3.7776 12.8332 1.16602 10.221 1.16602 6.99984C1.16602 3.77867 3.7776 1.1665 6.99935 1.1665ZM6.99935 2.13892C4.31893 2.13892 2.13843 4.31942 2.13843 6.99984C2.13843 9.68025 4.31893 11.8608 6.99935 11.8608C9.67976 11.8608 11.8603 9.68025 11.8603 6.99984C11.8603 4.31942 9.67976 2.13892 6.99935 2.13892ZM6.99857 8.45947C7.3203 8.45947 7.58112 8.72029 7.58112 9.04203C7.58112 9.36376 7.3203 9.62458 6.99857 9.62458C6.67683 9.62458 6.41602 9.36376 6.41602 9.04203C6.41602 8.72029 6.67683 8.45947 6.99857 8.45947ZM6.99612 4.08317C7.21761 4.08299 7.40079 4.24744 7.42993 4.46096L7.43397 4.52032L7.43607 7.14625C7.43626 7.38788 7.24054 7.58391 6.99892 7.5841C6.77743 7.58428 6.59425 7.41983 6.56511 7.20631L6.56107 7.14695L6.55897 4.52102C6.55878 4.2794 6.75449 4.08336 6.99612 4.08317Z" fill="currentColor"/></svg>`,
  add_connector: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"><path d="M16.167 2.077a.449.449 0 00-.738-.142L13 4.365a3.632 3.632 0 00-4.798.299l-.55.55a.945.945 0 000 1.336l2.496 2.49c.249-.18.515-.338.796-.47L8.567 6.194a.442.442 0 010-.624l.27-.27a2.729 2.729 0 013.858-.005l.005.01.006.005a2.732 2.732 0 01.648 2.8c.31.018.613.065.906.139a3.628 3.628 0 00-.62-3.25l2.43-2.43a.449.449 0 00.097-.492zM6.551 7.65l2.492 2.492c-.18.25-.339.516-.472.797L6.2 8.566a.441.441 0 00-.623 0l-.27.27a2.732 2.732 0 00-.005 3.858l.005.006.005.005a2.727 2.727 0 002.798.654c.02.307.066.607.139.896a3.635 3.635 0 01-3.246-.62l-2.43 2.43a.45.45 0 11-.64-.634l2.43-2.43a3.627 3.627 0 01.299-4.798l.27-.27.283-.283a.945.945 0 011.337 0zm8.749 8.768a4.05 4.05 0 11-4.5-6.736 4.05 4.05 0 014.5 6.736zm-1.932-5.486a.45.45 0 00-.768.318v1.35h-1.35a.45.45 0 000 .9h1.35v1.35a.45.45 0 00.9 0V13.5h1.35a.45.45 0 100-.9H13.5v-1.35a.45.45 0 00-.132-.318z" fill="currentColor"/></svg>`,
  expandArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="currentColor" d="M17.78 13.53a.75.75 0 0 1-1.06 0L10 6.81l-6.72 6.72a.75.75 0 0 1-1.06-1.06l7.25-7.25a.75.75 0 0 1 1.06 0l7.25 7.25a.75.75 0 0 1 0 1.06Z"/></svg>`,
  expand_more: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="currentColor"><path d="M9.5 1.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1.125a6.375 6.375 0 100 12.75 6.375 6.375 0 000-12.75zM6.102 7.477c.22-.22.576-.22.796 0L9.5 10.08l2.602-2.602a.562.562 0 11.796.796l-3 3a.562.562 0 01-.796 0l-3-3a.563.563 0 010-.796z" fill="currentColor"/></svg>`,
  collapse_less: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"><path d="M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-1.125a6.375 6.375 0 1 1 0-12.75 6.375 6.375 0 0 1 0 12.75Zm-3.398-4.852c.22.22.576.22.796 0L9 7.92l2.602 2.603a.562.562 0 1 0 .796-.796l-3-3a.563.563 0 0 0-.796 0l-3 3a.562.562 0 0 0 0 .796Z" fill="currentColor"/></svg>`,
  change_access_icon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M3 4.5V13.5C3 14.0179 3.23648 14.47 3.58068 14.8348C3.92205 15.1966 4.38975 15.4969 4.92501 15.7369C5.99681 16.2173 7.43803 16.5 9 16.5C9.38316 16.5 9.75905 16.483 10.124 16.4502C9.64032 16.1894 9.22382 15.82 8.90716 15.3746C7.50409 15.3636 6.26209 15.1034 5.3852 14.7103C4.93646 14.5091 4.60787 14.2842 4.39894 14.0628C4.19283 13.8443 4.125 13.6552 4.125 13.5V6.29432C4.3657 6.45961 4.63547 6.60707 4.92501 6.73686C5.99681 7.21732 7.43803 7.5 9 7.5C10.562 7.5 12.0032 7.21732 13.075 6.73686C13.3645 6.60707 13.6343 6.45961 13.875 6.29432V9.75H14.4375C14.6289 9.75 14.8168 9.76509 15 9.79416V4.5C15 3.98209 14.7635 3.52998 14.4193 3.16519C14.078 2.80338 13.6102 2.50308 13.075 2.26314C12.0032 1.78268 10.562 1.5 9 1.5C7.43803 1.5 5.99681 1.78268 4.92501 2.26314C4.38976 2.50308 3.92205 2.80338 3.58068 3.16519C3.23648 3.52998 3 3.98209 3 4.5ZM4.125 4.5C4.125 4.34482 4.19283 4.15569 4.39894 3.93724C4.60787 3.71581 4.93646 3.49087 5.3852 3.28971C6.28139 2.88797 7.55892 2.625 9 2.625C10.4411 2.625 11.7186 2.88797 12.6148 3.28971C13.0635 3.49087 13.3921 3.71581 13.6011 3.93724C13.8072 4.15569 13.875 4.34482 13.875 4.5C13.875 4.65518 13.8072 4.84431 13.6011 5.06276C13.3921 5.28419 13.0635 5.50913 12.6148 5.71029C11.7186 6.11203 10.4411 6.375 9 6.375C7.55892 6.375 6.28139 6.11203 5.3852 5.71029C4.93646 5.50913 4.60787 5.28419 4.39894 5.06276C4.19283 4.84431 4.125 4.65518 4.125 4.5ZM17.25 13.3125C17.25 11.7592 15.9908 10.5 14.4375 10.5L14.3612 10.5051C14.0866 10.5424 13.875 10.7777 13.875 11.0625C13.875 11.3732 14.1268 11.625 14.4375 11.625L14.553 11.6289C15.4311 11.6883 16.125 12.4194 16.125 13.3125C16.125 14.2445 15.3695 15 14.4375 15L14.4349 15.0034L14.3586 15.0089C14.0842 15.0474 13.8737 15.2838 13.875 15.5685C13.8764 15.8792 14.1294 16.1299 14.4401 16.1285V16.125L14.5892 16.1211C16.0707 16.0435 17.25 14.8157 17.25 13.3125ZM12.375 11.0625C12.375 10.7518 12.1232 10.5 11.8125 10.5L11.6631 10.5039C10.1793 10.5815 9 11.8093 9 13.3125C9 14.8658 10.2592 16.125 11.8125 16.125L11.8888 16.1199C12.1634 16.0826 12.375 15.8473 12.375 15.5625C12.375 15.2518 12.1232 15 11.8125 15L11.697 14.9961C10.8189 14.9367 10.125 14.2056 10.125 13.3125C10.125 12.3805 10.8805 11.625 11.8125 11.625L11.8888 11.6199C12.1634 11.5826 12.375 11.3473 12.375 11.0625ZM15 13.3125C15 13.0018 14.7482 12.75 14.4375 12.75H11.8125L11.7362 12.7551C11.4616 12.7924 11.25 13.0277 11.25 13.3125C11.25 13.6232 11.5018 13.875 11.8125 13.875H14.4375L14.5138 13.8699C14.7884 13.8326 15 13.5973 15 13.3125Z" fill="currentColor"/>
  </svg>`,
    send: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
    <path d="M4.27022 8.99999L1.7245 2.45387C1.54732 1.99826 1.99158 1.56256 2.43105 1.71743L2.50031 1.74688L16.0003 8.49688C16.389 8.69122 16.4133 9.22336 16.0732 9.45992L16.0003 9.50311L2.50031 16.2531C2.06308 16.4717 1.5881 16.0697 1.7016 15.6178L1.7245 15.5461L4.27022 8.99999L1.7245 2.45387L4.27022 8.99999ZM3.30158 3.4053L5.25832 8.43705L10.229 8.43749C10.5138 8.43749 10.7491 8.64911 10.7864 8.92367L10.7915 8.99999C10.7915 9.28477 10.5799 9.52011 10.3053 9.55736L10.229 9.56249L5.25832 9.56205L3.30158 14.5947L14.491 8.99999L3.30158 3.4053Z" fill="currentColor"/>
    </svg>`,
    close: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path fill="currentColor" d="m6.089 6.216.057-.07a.5.5 0 0 1 .638-.057l.07.057L12 11.293l5.146-5.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07L12.707 12l5.147 5.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057L12 12.707l-5.146 5.147a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07L11.293 12 6.146 6.854a.5.5 0 0 1-.057-.638l.057-.07-.057.07Z"/></svg>`,
    trash: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="currentColor" d="M7.5 3.75h3a1.5 1.5 0 1 0-3 0Zm-1.125 0a2.625 2.625 0 1 1 5.25 0h4.313a.562.562 0 1 1 0 1.125h-.99l-.879 9.083a2.813 2.813 0 0 1-2.8 2.542H6.73c-1.448 0-2.66-1.1-2.8-2.542l-.878-9.083h-.99a.563.563 0 0 1 0-1.125h4.313Zm1.5 3.563a.563.563 0 0 0-1.125 0v5.625a.562.562 0 1 0 1.125 0V7.311Zm2.813-.563c.31 0 .562.252.562.563v5.625a.562.562 0 1 1-1.125 0V7.311c0-.31.252-.562.563-.562Zm-5.637 7.1c.083.865.81 1.525 1.68 1.525h4.539c.869 0 1.596-.66 1.68-1.525l.868-8.975H4.182l.869 8.975Z"/></svg>`,
    arrowSync: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="currentColor" d="M12.188 3.885c-.189.247-.14.6.106.788a5.438 5.438 0 0 1-2.7 9.732l.508-.507a.563.563 0 0 0-.732-.85l-.063.054-1.5 1.5c-.2.2-.218.512-.055.733l.055.063 1.5 1.5a.562.562 0 0 0 .85-.733l-.055-.063-.562-.561a6.563 6.563 0 0 0 3.436-11.762.563.563 0 0 0-.788.106Zm-4.29-2.783a.563.563 0 0 0 0 .796l.562.561a6.563 6.563 0 0 0-3.637 11.603.562.562 0 1 0 .717-.867 5.438 5.438 0 0 1 2.865-9.6l-.507.507a.563.563 0 0 0 .795.796l1.5-1.5a.562.562 0 0 0 0-.796l-1.5-1.5a.562.562 0 0 0-.795 0Z"/></svg>`,
    shieldCheckMark: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="currentColor" d="M2.25 4.313c0-.311.252-.563.563-.563 1.997 0 3.943-.708 5.85-2.138.2-.15.474-.15.675 0 1.906 1.43 3.852 2.138 5.85 2.138.31 0 .562.252.562.563V8.25c0 .254-.01.503-.03.747a4.853 4.853 0 0 0-1.098-.513c.002-.077.003-.155.003-.234V4.858c-1.933-.114-3.81-.817-5.625-2.1-1.814 1.283-3.692 1.986-5.625 2.1V8.25c0 3.112 1.749 5.416 5.344 6.963.197.416.452.8.753 1.14-.088.037-.176.073-.266.108a.563.563 0 0 1-.412 0C4.468 14.757 2.25 12 2.25 8.25V4.312Zm15 8.812a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0Zm-1.61-1.765a.375.375 0 0 0-.53 0l-2.735 2.735-1.235-1.235a.375.375 0 0 0-.53.53l1.5 1.5a.375.375 0 0 0 .53 0l3-3a.375.375 0 0 0 0-.53Z"/></svg>`,
    source_Connecting: `<svg width="126" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M.667 8a5.333 5.333 0 1010.666 0A5.333 5.333 0 00.667 8zm8.208 1a1 1 0 000-2v2zm5.75-2a1 1 0 100 2V7zm5.75 2a1 1 0 100-2v2zm5.75-2a1 1 0 100 2V7zm5.75 2a1 1 0 100-2v2zm5.75-2a1 1 0 100 2V7zm5.75 2a1 1 0 100-2v2zm5.75-2a1 1 0 100 2V7zM6 9h2.875V7H6v2zm8.625 0h5.75V7h-5.75v2zm11.5 0h5.75V7h-5.75v2zm11.5 0h5.75V7h-5.75v2zm11.5 0H52V7h-2.875v2zM59 7a1 1 0 100 2V7zm66.707 1.707a1 1 0 000-1.414L119.343.929a1 1 0 10-1.414 1.414L123.586 8l-5.657 5.657a1 1 0 101.414 1.414l6.364-6.364zM61.75 9a1 1 0 100-2v2zm5.5-2a1 1 0 100 2V7zm5.5 2a1 1 0 100-2v2zm5.5-2a1 1 0 100 2V7zm5.5 2a1 1 0 100-2v2zm5.5-2a1 1 0 100 2V7zm5.5 2a1 1 0 100-2v2zm5.5-2a1 1 0 100 2V7zm5.5 2a1 1 0 000-2v2zm5.5-2a1 1 0 000 2V7zm5.5 2a1 1 0 000-2v2zm5.5-2a1 1 0 000 2V7zM59 9h2.75V7H59v2zm8.25 0h5.5V7h-5.5v2zm11 0h5.5V7h-5.5v2zm11 0h5.5V7h-5.5v2zm11 0h5.5V7h-5.5v2zm11 0h5.5V7h-5.5v2zm11 0H125V7h-2.75v2z" fill="currentColor"/></svg>`,
    card_Source: `<svg width="99" height="42" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20.25" fill="#FDFDFD" stroke="#83EDFB" stroke-width=".5"/><path d="M28.077 28.14c-8.546 4.339-13.85.708-17.244-1.497-.21-.139-.567.033-.258.412 1.131 1.463 4.838 4.99 9.676 4.99 4.842 0 7.722-2.819 8.082-3.31.358-.488.105-.757-.256-.595zm2.4-1.415c-.23-.319-1.396-.378-2.13-.282-.735.094-1.838.573-1.742.86.05.108.15.06.655.012.506-.054 1.924-.245 2.22.167.297.415-.453 2.392-.59 2.71-.132.32.051.402.3.19.244-.213.688-.763.985-1.54.296-.783.476-1.874.302-2.117z" fill="#F90"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.33 19.284c0 1.139.028 2.088-.512 3.1-.435.822-1.125 1.327-1.895 1.327-1.052 0-1.664-.855-1.664-2.117 0-2.49 2.091-2.943 4.072-2.943v.633zm2.763 7.123a.543.543 0 01-.647.07c-.91-.805-1.071-1.18-1.572-1.948-1.503 1.636-2.566 2.125-4.515 2.125-2.304 0-4.1-1.517-4.1-4.554 0-2.372 1.207-3.987 2.92-4.776 1.488-.699 3.564-.822 5.152-1.015v-.379c0-.694.05-1.516-.332-2.116-.335-.539-.974-.76-1.537-.76-1.044 0-1.976.57-2.203 1.754-.047.263-.228.522-.474.535l-2.659-.304c-.223-.054-.47-.247-.408-.613.613-3.436 3.521-4.472 6.125-4.472 1.334 0 3.075.378 4.127 1.455 1.332 1.328 1.205 3.1 1.205 5.027v4.554c0 1.369.532 1.969 1.033 2.709.177.263.216.58-.008.777-.559.497-1.553 1.422-2.1 1.94l-.007-.009" fill="#000"/><path d="M28.077 28.14c-8.546 4.339-13.85.708-17.244-1.497-.21-.139-.567.033-.258.412 1.131 1.463 4.838 4.99 9.676 4.99 4.842 0 7.722-2.819 8.082-3.31.358-.488.105-.757-.256-.595zm2.4-1.415c-.23-.319-1.396-.378-2.13-.282-.735.094-1.838.573-1.742.86.05.108.15.06.655.012.506-.054 1.924-.245 2.22.167.297.415-.453 2.392-.59 2.71-.132.32.051.402.3.19.244-.213.688-.763.985-1.54.296-.783.476-1.874.302-2.117z" fill="#F90"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.33 19.284c0 1.139.028 2.088-.512 3.1-.435.822-1.125 1.327-1.895 1.327-1.052 0-1.664-.855-1.664-2.117 0-2.49 2.091-2.943 4.072-2.943v.633zm2.763 7.123a.543.543 0 01-.647.07c-.91-.805-1.071-1.18-1.572-1.948-1.503 1.636-2.566 2.125-4.515 2.125-2.304 0-4.1-1.517-4.1-4.554 0-2.372 1.207-3.987 2.92-4.776 1.488-.699 3.564-.822 5.152-1.015v-.379c0-.694.05-1.516-.332-2.116-.335-.539-.974-.76-1.537-.76-1.044 0-1.976.57-2.203 1.754-.047.263-.228.522-.474.535l-2.659-.304c-.223-.054-.47-.247-.408-.613.613-3.436 3.521-4.472 6.125-4.472 1.334 0 3.075.378 4.127 1.455 1.332 1.328 1.205 3.1 1.205 5.027v4.554c0 1.369.532 1.969 1.033 2.709.177.263.216.58-.008.777-.559.497-1.553 1.422-2.1 1.94l-.007-.009" fill="#000"/><circle cx="49.5" cy="21" r="20.25" fill="#FDFDFD" stroke="#83EDFB" stroke-width=".5"/><path d="M57.077 28.14c-8.546 4.339-13.85.708-17.244-1.497-.21-.139-.567.033-.258.412 1.131 1.463 4.838 4.99 9.676 4.99 4.842 0 7.722-2.819 8.082-3.31.358-.488.105-.757-.256-.595zm2.4-1.415c-.23-.319-1.396-.378-2.13-.282-.735.094-1.838.573-1.742.86.05.108.15.06.655.012.506-.054 1.924-.245 2.22.167.297.415-.453 2.392-.59 2.71-.132.32.051.402.3.19.244-.213.688-.763.985-1.54.296-.783.476-1.874.302-2.117z" fill="#F90"/><path fill-rule="evenodd" clip-rule="evenodd" d="M51.33 19.284c0 1.139.028 2.088-.512 3.1-.435.822-1.125 1.327-1.895 1.327-1.052 0-1.664-.855-1.664-2.117 0-2.49 2.091-2.943 4.072-2.943v.633zm2.763 7.123a.543.543 0 01-.647.07c-.91-.805-1.071-1.18-1.572-1.948-1.503 1.636-2.566 2.125-4.515 2.125-2.304 0-4.1-1.517-4.1-4.554 0-2.372 1.207-3.987 2.92-4.776 1.488-.699 3.564-.822 5.152-1.015v-.379c0-.694.05-1.516-.332-2.116-.335-.539-.974-.76-1.537-.76-1.044 0-1.976.57-2.203 1.754-.047.263-.228.522-.474.535l-2.658-.304c-.224-.054-.47-.247-.409-.613.613-3.436 3.521-4.472 6.125-4.472 1.333 0 3.075.378 4.126 1.455 1.333 1.328 1.206 3.1 1.206 5.027v4.554c0 1.369.532 1.969 1.033 2.709.177.263.215.58-.008.777-.559.497-1.553 1.422-2.1 1.94l-.007-.009" fill="#000"/><path d="M57.077 28.14c-8.546 4.339-13.85.708-17.244-1.497-.21-.139-.567.033-.258.412 1.131 1.463 4.838 4.99 9.676 4.99 4.842 0 7.722-2.819 8.082-3.31.358-.488.105-.757-.256-.595zm2.4-1.415c-.23-.319-1.396-.378-2.13-.282-.735.094-1.838.573-1.742.86.05.108.15.06.655.012.506-.054 1.924-.245 2.22.167.297.415-.453 2.392-.59 2.71-.132.32.051.402.3.19.244-.213.688-.763.985-1.54.296-.783.476-1.874.302-2.117z" fill="#F90"/><path fill-rule="evenodd" clip-rule="evenodd" d="M51.33 19.284c0 1.139.028 2.088-.512 3.1-.435.822-1.125 1.327-1.895 1.327-1.052 0-1.664-.855-1.664-2.117 0-2.49 2.091-2.943 4.072-2.943v.633zm2.763 7.123a.543.543 0 01-.647.07c-.91-.805-1.071-1.18-1.572-1.948-1.503 1.636-2.566 2.125-4.515 2.125-2.304 0-4.1-1.517-4.1-4.554 0-2.372 1.207-3.987 2.92-4.776 1.488-.699 3.564-.822 5.152-1.015v-.379c0-.694.05-1.516-.332-2.116-.335-.539-.974-.76-1.537-.76-1.044 0-1.976.57-2.203 1.754-.047.263-.228.522-.474.535l-2.658-.304c-.224-.054-.47-.247-.409-.613.613-3.436 3.521-4.472 6.125-4.472 1.333 0 3.075.378 4.126 1.455 1.333 1.328 1.206 3.1 1.206 5.027v4.554c0 1.369.532 1.969 1.033 2.709.177.263.215.58-.008.777-.559.497-1.553 1.422-2.1 1.94l-.007-.009" fill="#000"/><g clip-path="url(#prefix__clip0_3646_3151)"><circle cx="78.5" cy="21" r="20.25" fill="#CAF9FF" stroke="#83EDFB" stroke-width=".5"/><path d="M73.777 20.045v1.483h-6.823v-1.483h6.823zm-2.612-2.79v7.247h-1.592v-7.246h1.592zm10.641 6.933V25.5h-6.671v-1.128l3.24-3.534c.355-.401.635-.748.84-1.04.206-.29.35-.553.431-.785.087-.237.13-.467.13-.69 0-.315-.06-.59-.178-.828a1.301 1.301 0 00-.505-.567c-.224-.142-.495-.212-.814-.212-.369 0-.679.08-.93.24-.25.159-.44.38-.567.662a2.271 2.271 0 00-.191.957h-1.648c0-.579.132-1.107.397-1.586a2.9 2.9 0 011.148-1.148c.501-.287 1.105-.43 1.812-.43.665 0 1.23.11 1.695.334.465.223.818.54 1.06.95.246.41.369.896.369 1.456 0 .31-.05.618-.15.923-.101.306-.245.61-.431.916a7.86 7.86 0 01-.65.91c-.25.3-.526.606-.827.915l-2.153 2.372h4.593zm8.242-2.236v1.313H82.87l-.054-.992 4.293-6.726h1.319l-1.429 2.447-2.468 3.958h5.517zm-1.244-6.405V25.5h-1.648v-9.953h1.648z" fill="#006775"/></g><defs><clipPath id="prefix__clip0_3646_3151"><path fill="currentColor" transform="translate(58 .5)" d="M0 0h41v41H0z"/></clipPath></defs></svg>`,
    database_Plug_Connected: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="currentColor">
    <path d="M8.40039 10.5002C8.40039 8.38553 10.2379 6.81473 12.3904 5.83193C15.1169 4.69914 18.0485 4.14356 21.0004 4.20023C23.9523 4.14356 26.8839 4.69914 29.6104 5.83193C31.7629 6.81473 33.6004 8.38553 33.6004 10.5002V21.2289C32.9479 21.2797 32.3065 21.4331 31.6999 21.6844C31.6329 21.7122 31.5663 21.7411 31.5004 21.7712V14.0702C30.9112 14.5035 30.2776 14.8731 29.6104 15.1727C26.8836 16.3041 23.952 16.8582 21.0004 16.8002C18.0485 16.8569 15.1169 16.3013 12.3904 15.1685C11.7234 14.8702 11.0898 14.5021 10.5004 14.0702V31.5002C10.5004 32.2856 11.248 33.3377 13.2682 34.2575C15.7194 35.2635 18.3513 35.7546 21.0004 35.7002L21.0451 35.7011C21.069 35.8141 21.0961 35.9266 21.1264 36.0385L19.5304 37.6429C19.4887 37.6847 19.4482 37.7276 19.409 37.7715C16.9995 37.6381 14.626 37.0974 12.3904 36.1685C10.2379 35.1857 8.40039 33.6149 8.40039 31.5002V10.5002ZM10.5004 10.5002C10.5004 11.2856 11.248 12.3377 13.2682 13.2575C15.7194 14.2635 18.3513 14.7546 21.0004 14.7002C23.6495 14.7546 26.2814 14.2635 28.7326 13.2575C30.7528 12.3377 31.5004 11.2856 31.5004 10.5002C31.5004 9.71483 30.7528 8.66273 28.7326 7.74293C26.2814 6.7369 23.6495 6.24583 21.0004 6.30023C18.3513 6.24583 15.7194 6.7369 13.2682 7.74293C11.248 8.66273 10.5004 9.71483 10.5004 10.5002ZM40.316 22.7939C40.5132 22.597 40.6241 22.3298 40.6243 22.0512C40.6245 21.7726 40.514 21.5053 40.3171 21.3081C40.1202 21.111 39.8531 21.0001 39.5744 20.9999C39.2958 20.9997 39.0285 21.1102 38.8313 21.3071L36.3407 23.7977C36.3143 23.8335 36.2898 23.8706 36.2672 23.909C35.4658 23.4306 34.5278 23.2329 33.6014 23.347C32.6751 23.4611 31.8131 23.8805 31.1516 24.539L29.8916 25.799C29.5061 26.1852 29.2896 26.7086 29.2896 27.2543C29.2896 27.7999 29.5061 28.3233 29.8916 28.7096L32.9198 31.7315C33.3061 32.1176 33.83 32.3345 34.3762 32.3345C34.9224 32.3345 35.4462 32.1176 35.8325 31.7315L37.0925 30.4715C37.7515 29.8098 38.1712 28.9475 38.2853 28.0207C38.3994 27.0939 38.2014 26.1554 37.7225 25.3538C37.7616 25.3325 37.7989 25.3079 37.8338 25.2803L40.316 22.7939ZM28.4062 30.1878C28.2151 29.9967 27.9882 29.8451 27.7385 29.7416C27.4888 29.6382 27.2212 29.585 26.9509 29.585C26.6807 29.585 26.413 29.6382 26.1633 29.7416C25.9136 29.8451 25.6867 29.9967 25.4956 30.1878L24.2356 31.4478C23.5766 32.1094 23.1569 32.9718 23.0428 33.8986C22.9287 34.8254 23.1268 35.7638 23.6056 36.5655C23.5668 36.5873 23.5296 36.6119 23.4943 36.639L21.0121 39.1275C20.8209 39.3255 20.715 39.5908 20.7174 39.8661C20.7198 40.1414 20.8302 40.4047 21.0249 40.5994C21.2196 40.7941 21.483 40.9045 21.7583 40.9069C22.0336 40.9093 22.2988 40.8035 22.4968 40.6122L24.9853 38.1216C25.0129 38.0862 25.0382 38.049 25.0609 38.0103C25.8624 38.4886 26.8004 38.6864 27.7267 38.5723C28.6531 38.4582 29.5151 38.0388 30.1765 37.3803L31.4365 36.1203C31.8227 35.734 32.0396 35.2102 32.0396 34.664C32.0396 34.1178 31.8227 33.5939 31.4365 33.2076L28.4062 30.1878Z" fill="currentColor"/>
  </svg>`,
  circleCheck: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"><path d="M7 1.167a5.833 5.833 0 110 11.667A5.833 5.833 0 017 1.167zm0 .875a4.958 4.958 0 100 9.917 4.958 4.958 0 000-9.917zM6.271 7.84l2.607-2.607a.437.437 0 01.662.57l-.043.048-2.916 2.917a.438.438 0 01-.57.042l-.05-.042L4.504 7.31a.437.437 0 01.57-.661l.05.042L6.27 7.84l2.607-2.607L6.271 7.84z" fill="currentColor"/></svg>`,
  circlePause: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"><path d="M6.124 4.812a.437.437 0 1 0-.875 0v4.375a.437.437 0 1 0 .875 0V4.812Zm2.625 0a.437.437 0 1 0-.875 0v4.375a.437.437 0 1 0 .875 0V4.812ZM7 1.166a5.833 5.833 0 1 0 0 11.667A5.833 5.833 0 0 0 7 1.166ZM2.041 7a4.958 4.958 0 1 1 9.917 0A4.958 4.958 0 0 1 2.04 7Z" fill="currentColor"/></svg>`,
  synchronising: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"><path d="M9.48 3.022a.437.437 0 0 0 .083.613 4.23 4.23 0 0 1-2.1 7.57l.395-.396a.437.437 0 0 0-.57-.66l-.049.042-1.166 1.166a.438.438 0 0 0-.043.57l.043.049 1.166 1.166a.437.437 0 0 0 .661-.57l-.042-.048-.438-.437a5.105 5.105 0 0 0 2.673-9.148.437.437 0 0 0-.613.083ZM6.143.857a.438.438 0 0 0 0 .619l.437.437a5.105 5.105 0 0 0-2.828 9.024.437.437 0 1 0 .557-.675 4.23 4.23 0 0 1 2.228-7.466l-.394.394a.438.438 0 0 0 .62.62l1.166-1.167a.438.438 0 0 0 0-.62L6.762.858a.438.438 0 0 0-.619 0Z" fill="currentColor"/></svg>`,
  circleError: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"><path d="M7 1.167a5.834 5.834 0 1 1-.001 11.667 5.834 5.834 0 0 1 0-11.668Zm0 .972c-2.681 0-4.862 2.18-4.862 4.86 0 2.681 2.18 4.862 4.861 4.862 2.68 0 4.861-2.18 4.861-4.861 0-2.68-2.18-4.861-4.86-4.861Zm-.001 6.32a.583.583 0 1 1 0 1.166.583.583 0 0 1 0-1.166Zm-.003-4.376c.222 0 .405.164.434.378l.004.06.002 2.625a.437.437 0 0 1-.87.06l-.005-.06-.002-2.625c0-.242.195-.438.437-.438Z" fill="currentColor"/></svg>`,
  customerSupport: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"><path d="M15 12.184c0-.931-.755-1.686-1.687-1.686H4.687c-.932 0-1.687.755-1.687 1.686v.434c0 .67.239 1.317.674 1.826 1.174 1.376 2.964 2.055 5.323 2.055 2.36 0 4.15-.68 5.327-2.054.436-.51.676-1.158.676-1.83v-.43Zm-10.313-.561h8.626c.31 0 .562.251.562.561v.432c0 .402-.144.792-.406 1.097-.942 1.101-2.418 1.66-4.472 1.66-2.053 0-3.528-.559-4.468-1.66a1.687 1.687 0 0 1-.404-1.095v-.434c0-.31.251-.561.562-.561Zm8.06-6.372A3.75 3.75 0 0 0 5.98 3.026.562.562 0 0 0 5.81 3H3.937a.563.563 0 0 0-.562.563v4.124c0 1.139.923 2.062 2.062 2.062h.188v-.003h.008a.748.748 0 1 0-.59-1.208.938.938 0 0 1-.543-.851v-.188h.56c.286 0 .55-.091.766-.246a3.75 3.75 0 0 0 6.922-2.002Zm-7.499-.08a3.82 3.82 0 0 0 0 .16v.856a.187.187 0 0 1-.187.187H4.5V4.125h.748v1.047Zm1.125.147v-.133a2.625 2.625 0 1 1 0 .133Z" fill="currentColor"/></svg>`,
  connector_img: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="currentColor"><mask id="a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="18"><path fill="currentColor" d="M.5 0h18v18H.5z"/></mask><g mask="url(#a)"><path d="M9.125 14.25h.75v-1.387l2.625-2.625V6.75h-6v3.488l2.625 2.625v1.387zm-1.5-.75-2.194-2.194A1.48 1.48 0 0 1 5 10.256V6.75c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h.75L6.5 6V3c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .39.072.534.216A.726.726 0 0 1 8 3v2.25h3V3c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .39.072.534.216A.726.726 0 0 1 12.5 3v3l-.75-.75h.75c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v3.506a1.48 1.48 0 0 1-.431 1.05L11.375 13.5V15c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216h-2.25a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-1.5z" fill="currentColor"/></g></svg>`,
  addSourceImg: `<svg xmlns="http://www.w3.org/2000/svg" width="77" height="66" fill="none"><path fill="#83EDFB" stroke="#83EDFB" d="M1 46V4.655A4 4 0 0 1 5.602.7l38 5.783A4 4 0 0 1 47 10.437V46a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4Z"/><path fill="#00BCD4" d="M15.25 10.313a2.062 2.062 0 1 1 4.125 0V27.52l10.04-5.284a2.062 2.062 0 0 1 2.006.048l10.504 6.178 15.4-11.55a2.063 2.063 0 0 1 3.3 1.65v35.062h2.063a2.062 2.062 0 1 1 0 4.125H17.313a2.062 2.062 0 0 1-2.063-2.063V10.313Zm4.125 21.87v21.442H56.5V22.687l-13.2 9.9a2.06 2.06 0 0 1-2.283.128L30.32 26.423l-10.945 5.76Z"/><path fill="#83EDFB" stroke="#83EDFB" d="M65 10V6.657a4 4 0 0 1 4.604-3.954l3 .458A4 4 0 0 1 76 7.115V10a4 4 0 0 1-4 4h-3a4 4 0 0 1-4-4Z"/></svg>`,
  warningSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"><path d="M10.03 3.659c.856-1.548 3.081-1.548 3.937 0l7.746 14.001c.83 1.5-.255 3.34-1.969 3.34H4.254c-1.715 0-2.8-1.84-1.97-3.34L10.03 3.66ZM12.997 17A.999.999 0 1 0 11 17a.999.999 0 0 0 1.997 0Zm-.259-7.853a.75.75 0 0 0-1.493.103l.004 4.501.007.102a.75.75 0 0 0 1.493-.103l-.004-4.502-.007-.101Z" fill="#F2A309"/></svg>`,
  dismissIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.53 6.47-.084-.073a.75.75 0 0 0-.882-.007l-.094.08L12 10.939l-2.47-2.47-.084-.072a.75.75 0 0 0-.882-.007l-.094.08-.073.084a.75.75 0 0 0-.007.882l.08.094L10.939 12l-2.47 2.47-.072.084a.75.75 0 0 0-.007.882l.08.094.084.073a.75.75 0 0 0 .882.007l.094-.08L12 13.061l2.47 2.47.084.072a.75.75 0 0 0 .882.007l.094-.08.073-.084a.75.75 0 0 0 .007-.882l-.08-.094L13.061 12l2.47-2.47.072-.084a.75.75 0 0 0 .007-.882l-.08-.094-.084-.073.084.073Z" fill="#BD271E"/></svg>`,
  checkMark: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06Z" fill="#33961F"/></svg>`,
  lockIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" ><path d="M10 10a1 1 0 1 1-2 0 1 1 0 1 1 2 0zM6 5h-.5A2.5 2.5 0 0 0 3 7.5v5A2.5 2.5 0 0 0 5.5 15h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 5H12v-.5a3 3 0 1 0-6 0V5zm1-.5a2 2 0 1 1 4 0V5H7v-.5zM12.5 6A1.5 1.5 0 0 1 14 7.5v5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5v-5A1.5 1.5 0 0 1 5.5 6h7z" fill="currentColor"/></svg>`,
  upgradeIcon: `<svg viewBox="0 0 84 57" xmlns="http://www.w3.org/2000/svg"><circle cx="37.5" cy="35.5" r="21.5" fill="#D8CCFA"/><path d="m37.8 31 .2.2q1 .7 2.1-.1l5.8-5.8v14.4c0 .8.8 1.4 1.6 1.4h.2q1.2-.3 1.3-1.6V25.3l5.8 5.8.2.1a1.6 1.6 0 0 0 2-2.4l-8.4-8.5-.2-.1q-1-.8-2 .1l-8.6 8.5-.1.2q-.7 1 .1 2m30.9-.5a21.2 21.2 0 1 0-42.5 0 21.2 21.2 0 0 0 42.5 0m-39.3 0a18 18 0 1 1 36 0 18 18 0 0 1-36 0" fill="#825CEE"/><circle cx="79" cy="5" r="5" fill="#D8CCFA"/><circle cx="4" cy="23" r="4" fill="#D8CCFA"/></svg>`,
  generatorIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="90" height="57" fill="none"><circle cx="37.5" cy="35.5" r="21.5" fill="#B8D4F7"/><circle cx="79" cy="5" r="5" fill="#B8D4F7"/><circle cx="4" cy="23" r="4" fill="#B8D4F7"/><path d="M32.071 17.071a3.571 3.571 0 0 1 3.571-3.571h10.715a3.571 3.571 0 0 1 3.571 3.571v1.786a3.571 3.571 0 0 1-3.571 3.571H35.642a3.571 3.571 0 0 1-3.571-3.571V17.07Zm3.571-.893c-.493 0-.892.4-.892.893v1.786c0 .493.4.893.892.893h10.715c.493 0 .893-.4.893-.893V17.07c0-.493-.4-.893-.893-.893H35.642Zm-1.339 14.286a2.232 2.232 0 1 0 0-4.464 2.232 2.232 0 0 0 0 4.464Zm2.232 4.91a2.232 2.232 0 1 1-4.464 0 2.232 2.232 0 0 1 4.464 0Zm11.161-4.91a2.232 2.232 0 1 0 0-4.464 2.232 2.232 0 0 0 0 4.464Zm2.232 4.91a2.232 2.232 0 1 1-4.464 0 2.232 2.232 0 0 1 4.464 0ZM41 30.465A2.232 2.232 0 1 0 41 26a2.232 2.232 0 0 0 0 4.464Zm2.232 4.91a2.232 2.232 0 1 1-4.465 0 2.232 2.232 0 0 1 4.465 0ZM32.517 8.144a5.803 5.803 0 0 0-5.803 5.803v24.107a5.804 5.804 0 0 0 5.803 5.804h16.965a5.804 5.804 0 0 0 5.803-5.804V13.946a5.804 5.804 0 0 0-5.803-5.803H32.517Zm-3.125 5.803c0-1.726 1.4-3.125 3.125-3.125h16.965c1.726 0 3.125 1.4 3.125 3.125v24.107c0 1.726-1.4 3.125-3.125 3.125H32.517a3.125 3.125 0 0 1-3.125-3.125V13.946Z" fill="#1B77E4"/></svg>`,
  closeIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" fill="none"><path d="M16 18.1 9.1 25a1.091 1.091 0 0 1-.8.334c-.311 0-.578-.111-.8-.334a1.091 1.091 0 0 1-.333-.8c0-.31.11-.578.333-.8l6.9-6.9-6.9-6.9a1.091 1.091 0 0 1-.333-.8c0-.31.11-.577.333-.8.222-.222.489-.333.8-.333.311 0 .578.111.8.333l6.9 6.9L22.9 8c.222-.222.489-.333.8-.333.311 0 .578.111.8.333.222.223.333.49.333.8 0 .311-.11.578-.333.8l-6.9 6.9 6.9 6.9c.222.223.333.49.333.8 0 .311-.11.578-.333.8a1.091 1.091 0 0 1-.8.334c-.311 0-.578-.111-.8-.334L16 18.1Z" fill="#757575"/></svg>`
};


export const FREQUENCY_KEYS = {
    CRON_FREQUENCY: 'cronFrequency',
    TIMEZONE_FOR_CRON_FREQUENCY: 'timeZoneForCronFrequency',
    CRON_FREQUENCY_TYPE: 'cronFrequencyType',
    PERIODIC_FREQUENCY: 'periodicFrequency'
};

export function getNestedFormControlPath(...keys: string[]): string {
    return keys.join('.');
}

export const downloadFile = (blob, filename) => {
    try {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a); // This line is required in Firefox
        a.click();
        URL.revokeObjectURL(objectUrl);
        a.remove(); // Remove the element after download
    } catch (error) {
        console.log(error)
    }
}

export const getSingularOrPluralForm = (id: string, count: number): string => {
    // Singular case: if count is 1
    if (count === 1) {
      // Convert 'ies' back to 'y'
      if (_endsWith(id, 'ies')) {
        return id.slice(0, -3) + 'y';
      }
      // Remove trailing 's' if it is already plural
      if (_endsWith(id,'s')) {
        return id.slice(0, -1);
      }
      return id; // Return as is if it's singular
    }

    // Handle words ending in 'y' and not preceded by a vowel
    if (_endsWith(id,'y') && !_includes(['a', 'e', 'i', 'o', 'u'],id[id.length - 2])) {
      return id.slice(0, -1) + 'ies';
    }

    // Handle words already in plural form
    if (_endsWith(id,'s')) {
      return id;
    }

    // Default rule: add 's'
    return id + 's';
  }


  export const trackSearchEvents = (searchTerm, isOptionAvailable) => {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: "view_search_results",
      search_term: searchTerm,
      options_available: isOptionAvailable
    });
  }
  let _localStorageAvailable: boolean | null = null;
  /**
   * Returns true if localStorage is accessible and writable in the current context.
   * Runs a live window.localStorage existence check on every call so that a transient
   * null state (e.g. Safari ITP on /close/) is never cached as a permanent "false".
   * Only the result of the write-test is cached.
   */
  export function isLocalStorageAvailable(): boolean {
    // Live check — never cache failures here, since the null state can recover on
    // subsequent navigations within the same SPA session.
    try {
      if (typeof window === 'undefined' || !window.localStorage) return false;
    } catch {
      return false;
    }

    if (_localStorageAvailable !== null) return _localStorageAvailable;

    try {
      const probe = '__saras_ls_probe__';
      localStorage.setItem(probe, probe);
      localStorage.removeItem(probe);
      _localStorageAvailable = true;
    } catch {
      // Don't cache false — ITP restrictions can be transient
      return false;
    }
    return _localStorageAvailable;
  }

  export function shouldShowChip(planType?: string, userPlan?: string): boolean {
    if (!planType || !userPlan) return false;
    switch (userPlan.toUpperCase()) {
      case 'TRIAL':
        return true;
      case 'LITE':
        return planType.toUpperCase() !== 'LITE';
      case 'GROWTH':
        return planType.toUpperCase() === 'ENTERPRISE';
      case 'ENTERPRISE':
        return false;
      default:
        return false;
    }
  }

/**
 * Determines whether to route to source-service (true) or old service (false).
 *
 * CREATING (datasource-level isLegacy from /datasources/combined):
 *   isLegacy=false → source-service
 *   isLegacy=true  → old service
 *
 * EDIT / RE-AUTH / STATUS / DETAIL:
 *   Listing page (both flags available – use integration isLegacy):
 *     isLegacy=false → source-service
 *     isLegacy=true  → old service
 *   Detail page (entity only, no isLegacy):
 *     migrated=true  → source-service
 *     migrated=false → source-service (native CDK / default)
 *
 * NOTE: isLegacy takes priority over migrated when available.
 *       Undo'd migrations retain isLegacy=true, so the isLegacy
 *       branch already handles that scenario correctly.
 */
export function shouldUseSourceService(flags: { isLegacy?: boolean; migrated?: boolean }): boolean {
  if (flags.isLegacy === false) return true;
  if (flags.isLegacy === true) return false;
  // isLegacy not available – use migrated as fallback
  if (flags.migrated === true) return true;
  return true;
}

/**
 * Opens the Freshworks support ticket form. The widget script loads
 * asynchronously, so `window['FreshworksWidget']` can be undefined when the
 * user clicks Support before it's ready — fall back to a snackbar instead of
 * silently doing nothing.
 */
export function openSupportWidget(snackBar: SnackBarService): void {
  const widget = window['FreshworksWidget'];
  if (widget) {
    widget('open', 'ticketForm');
  } else {
    snackBar.open('Support is still loading. Please try again in a moment.');
  }
}
